import React from 'react';
import '../template-file-css/document-file-template.css';


export const NWBH_BPSAdult = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='NWBH_BPSAdult' className='file-pdf-document'>
            <div className='file-template'>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>CR#</span>
                            <input type='text' id='txtCR' name='txtCR' className='add-only' />
                        </td>

                        <td className='w-375'>
                            <span className='eleHeader'>Referral Source</span>
                            <input type='text' id='txtReferralSource' name='txtReferralSource' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Primary Language Spoken in the home</span>
                            <input type='text' id='txtPrimaryLanguage' name='txtPrimaryLanguage' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Other Languages Spoken in the home</span>
                            <input type='text' id='txtOtherLanguage' name='txtOtherLanguage' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Does the client or family member involved in client's
                                treatment need the services of a translator?</span>
                            <input type='radio' id='rbTranslator_Yes' name='rbTranslator' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbTranslator_No' name='rbTranslator' className='add-only' value='No' /> No
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Does the client have any history of or current speech or language impairment?</span>
                    <input type='radio' id='rbCurrentSpeech_Yes' name='rbCurrentSpeech' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbCurrentSpeech_No' name='rbCurrentSpeech' className='add-only' value='No' /> No
                    <span className='small'>If yes, please explain</span>
                    <textarea id='txtCurrentSpeech' name='txtCurrentSpeech' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Does the client have any history of or current visual impairment?</span>
                    <input type='radio' id='rbCurrentVisual_Yes' name='rbCurrentVisual' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbCurrentVisual_No' name='rbCurrentVisual' className='add-only' value='No' /> No
                    <span className='small'>If yes, please explain</span>
                    <textarea id='txtrbCurrentVisual' name='txtrbCurrentVisual' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Does the client have any history of or current hearing impairment?</span>
                    <input type='radio' id='rbCurrentHearing_Yes' name='rbCurrentHearing' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbCurrentHearing_No' name='rbCurrentHearing' className='add-only' value='No' /> No
                    <span className='small'>If yes, please explain</span>
                    <textarea id='txtCurrentHearing' name='txtCurrentHearing' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Are there other special physical needs identified for the person served or family?</span>
                    <input type='radio' id='rbPhysicalNeeds_Yes' name='rbPhysicalNeeds' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbPhysicalNeeds_No' name='rbPhysicalNeeds' className='add-only' value='No' /> No
                    <span className='small'>(Please specify)</span>
                    <textarea id='txtPhysicalNeeds' name='txtPhysicalNeeds' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Home Address</span>
                            <input type='text' id='txtHomeAddress' name='txtHomeAddress' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Home Phone #</span>
                            <input type='text' id='txtHomePhone' name='txtHomePhone' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Work Phone #</span>
                            <input type='text' id='txtWorkPhone' name='txtWorkPhone' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Emergency Contact</span>
                            <input type='text' id='txtEmergencyContact' name='txtEmergencyContact' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Relationship</span>
                            <input type='text' id='txtRelationship' name='txtRelationship' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Phone #</span>
                            <input type='text' id='txtPhone_Emergency' name='txtPhone_Emergency' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Emergency Contact Address</span>
                            <input type='text' id='txtEmergencyAddress' name='txtEmergencyAddress' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>City/State</span>
                            <input type='text' id='txtEmergencyCity' name='txtEmergencyCity' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Zip Code</span>
                            <input type='text' id='txtEmergencyZip' name='txtEmergencyZip' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Case Worker</span>
                            <input type='text' id='txtCaseWorker' name='txtCaseWorker' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Program</span>
                            <input type='text' id='txtProgram' name='txtProgram' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Phone #</span>
                            <input type='text' id='txtPhone' name='txtPhone' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Guardian Ad-Litem</span>
                            <input type='text' id='txtGuardianLitem' name='txtGuardianLitem' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Phone #</span>
                            <input type='text' id='txtGuardianPhone' name='txtGuardianPhone' className='add-only' />
                        </td>
                    </tr>
                </table>
                <span className='eleHeader'>Household Members</span>
                <table>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbHusband_Household' name='cbHusband_Household' className='add-only' value='1' />
                            Husband: &nbsp;
                            <input type='text' id='txtHusband' name='txtHusband' className='add-only w-150 custom-add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbWife_Household' name='cbWife_Household' className='add-only' value='1' />
                            Wife: &nbsp;
                            <input type='text' name='txtWife' id='txtWife' className='add-only w-150 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbSon_Household' name='cbSon_Household' className='add-only' value='1' />
                            Son(s): &nbsp;
                            #<input type='text' id='txtSon' name='txtSon' className='add-only w-50 custom-add-only' /> &nbsp;
                            age(s) &nbsp;
                            <input type='text' id='txtAge_Son' name='txtAge_Son' className='add-only w-50 custom-add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbDaughter_Household' name='cbDaughter_Household' className='add-only' value='1' />
                            Daughter(s): &nbsp;
                            <input type='text' id='txtDaughter' name='txtDaughter' className='add-only w-50 custom-add-only' /> &nbsp;
                            age(s) &nbsp;
                            <input type='text' id='txtAge_Daughter' name='txtAge_Daughter' className='add-only w-50 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbSignificant_Household' name='cbSignificant_Household' className='add-only' value='1' />Significant other: &nbsp;
                            <input type='text' id='txtSignificant' name='txtSignificant' className='add-only w-150 custom-add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbMother_Household' name='cbMother_Household' className='add-only' value='1' />
                            Mother: &nbsp;
                            <input type='text' id='txtMother' className='add-only w-150 custom-add-only' name='txtMother' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbFather_Household' name='cbFather_Household' className='add-only' value='1' />
                            Father: &nbsp;
                            <input type='text' id='txtFather' className='add-only w-150 custom-add-only' name='txtFather' />
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbGrandmother_Household' name='cbGrandmother_Household' className='add-only' value='1' />
                            Grandmother: &nbsp;
                            <input type='text' id='txtGrandMother' className='add-only w-150 custom-add-only' name='txtGrandMother' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbGrandFather_Household' name='cbGrandFather_Household' className='add-only' value='1' />
                            Grandfather: &nbsp;
                            <input type='text' id='txtGrandFather' name='txtGrandFather' className='add-only w-150 custom-add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbSister_Household' name='cbSister_Household' className='add-only' value='1' />
                            Sister(s) # &nbsp;
                            <input type='text' id='txtSister' name='txtSister' className='add-only w-50 custom-add-only' /> &nbsp;
                            (age)(s): &nbsp;
                            <input type='text' id='txtAge_Sister' name='txtAge_Sister' className='add-only w-50 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbBrother_Household' name='cbBrother_Household' className='add-only' value='1' />
                            Brother # &nbsp;
                            <input type='text' id='txtBrother' name='txtBrother' className='add-only w-50 custom-add-only' /> &nbsp;
                            (age)(s): &nbsp;
                            <input type='text' id='txtAge_Brother' name='txtAge_Brother' className='add-only w-50 custom-add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbStepSister_Household' name='cbStepSister_Household' className='add-only' value='1' />
                            Stepsister # &nbsp;
                            <input type='text' id='txtStepSister' name='txtStepSister' className='add-only w-50 custom-add-only' /> &nbsp;
                            (age)(s): &nbsp;
                            <input type='text' id='txtAge_StepSister' name='txtAge_StepSister' className='add-only w-50 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbStepBrother_household' name='cbStepBrother_household' className='add-only' value='1' />
                            Stepbrother # &nbsp;<input type='text' id='txtStepBrother' name='txtStepBrother' className='add-only w-50 custom-add-only' /> &nbsp;
                            (age)(s): &nbsp;<input type='text' id='txtAge_StepBrother' name='txtAge_StepBrother' className='add-only w-50 custom-add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbOther_household' name='cbOther_household' className='add-only' value='1' />
                            Other (relationship/age):
                            <input type='text' id='txtOtherRelationship' name='txtOtherRelationship' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'><h2>Significant Others Note in the Home</h2></p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Relationship</span>
                            <input type='text' id='txtRelationship_Significant' name='txtRelationship_Significant' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Age</span>
                            <input type='text' id='txtAge_Significant' name='txtAge_Significant' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Location</span>
                            <input type='text' id='txtLocation_Significant' name='txtLocation_Significant' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Notes</span>
                    <textarea id='txtNotes_Significant' name='txtNotes_Significant' className='add-only'></textarea>
                </p>
                <p className='w-750'><h2>Assessment Information</h2></p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Assessment Participant(s)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAssInformation_Client' name='cbAssInformation_Client' className='add-only' value='1' />
                            Client
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAssInformation_Mother' name='cbAssInformation_Mother' className='add-only' value='1' />
                            Mother
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAssInformation_Father' name='cbAssInformation_Father' className='add-only' value='1' />
                            Father
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAssInformation_Stepmother' name='cbAssInformation_Stepmother' className='add-only' value='1' />
                            Stepmother
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAssInformation_Stepfather' name='cbAssInformation_Stepfather' className='add-only' value='1' />
                            Stepfather
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAssInformation_PaternalGrandmother' name='cbAssInformation_PaternalGrandmother' className='add-only' value='1' />
                            Paternal Grandmother
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAssInformation_PaternalGrandfather' name='cbAssInformation_PaternalGrandfather' className='add-only' value='1' />
                            Paternal Grandfather
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAssInformation_MaternalGrandmother' name='cbAssInformation_MaternalGrandmother' className='add-only' value='1' />
                            Maternal Grandmother
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAssInformation_MaternalGrandfather' name='cbAssInformation_MaternalGrandfather' className='add-only' value='1' />
                            Maternal Grandfather
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAssInformation_Aunt' name='cbAssInformation_Aunt' className='add-only' value='1' />
                            Aunt
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAssInformation_Uncle' name='cbAssInformation_Uncle' className='add-only' value='1' />
                            Uncle
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAssInformation_Sister' name='cbAssInformation_Sister' className='add-only' value='1' />
                            Sister(s) # &nbsp;
                            <input type='text' id='txtAssInformation_Sister' name='txtAssInformation_Sister' className='add-only w-50 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAssInformation_Brother' name='cbAssInformation_Brother' className='add-only' value='1' />
                            Brother(s) # &nbsp;
                            <input type='text' id='txtAssInformation_Brother' name='txtAssInformation_Brother' className='add-only w-50 custom-add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAssInformation_Stepsister' name='cbAssInformation_Stepsister' className='add-only' value='1' />
                            Stepsister(s) # &nbsp;
                            <input type='text' id='txtAssInformation_Stepsister' name='txtAssInformation_Stepsister' className='add-only w-50 custom-add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbAssInformation_Stepbrother' name='cbAssInformation_Stepbrother' className='add-only' value='1' />
                            Stepbrother(s) # &nbsp;
                            <input type='text' id='txtAssInformation_Stepbrother' name='txtAssInformation_Stepbrother' className='add-only w-50 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbAssInformation_Other' name='cbAssInformation_Other' className='add-only' value='1' />
                            Other: (specify) &nbsp;
                            <input type='text' id='txtcbAssInformation_OtherSpecify' name='txtcbAssInformation_OtherSpecify' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'><h2>Client's Presenting Issue(s)</h2></p>
                <p className='w-750'>
                    <span className='eleHeader'>Description of Problem/s: What are some issues/problems you are having caused by your behavior(s)?</span>
                    <span className='small'>(Use the person served own words, include symptoms, frequencies, duration, precipitant events, barriers in coping with situations)</span>
                    <textarea id='txtDescriptionProblem' name='txtDescriptionProblem' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>What are some things you think you need to work on?</span>
                    <span className='small'>(Person Served Description of Needed Changes)</span>
                    <textarea id='txtNeededChanges' name='txtNeededChanges' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Spouse/Significant Other what are some behaviors he/she needs to improve?</span>
                    <span className='small'>(Partner/Family Description of Needed Changes)</span>
                    <textarea id='txtSpouseBehaviors' name='txtSpouseBehaviors' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Notes</span>
                    <textarea id='txtNotesPresenting' name='txtNotesPresenting' className='add-only'></textarea>
                </p>
                <p className='w-750'><h4>Recipient Residential History</h4></p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>How long has client lived at current address</span>
                            <input type='text' id='txtCurrentAddress' name='txtCurrentAddress' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Has client ever been homeless</span>
                            <input type='text' id='txtHomeless' name='txtHomeless' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Has client ever lived with someone else</span>
                            <input type='radio' id='rbClientLived_Yes' name='rbClientLived' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbClientLived_No' name='rbClientLived' className='add-only' value='No' /> No
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>If yes Who</span>
                            <input type='text' id='txtWithWho' name='txtWithWho' className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Client reports</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbClientReport_No' name='cbClientReport_No' className='add-only' value='1' />
                            No
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbClientReport_Minimal' name='cbClientReport_Minimal' className='add-only' value='1' />
                            Minimal
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbClientReport_Significant' name='cbClientReport_Significant' className='add-only' value='1' />
                            Significant problems with their current neighborhood
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbClientReport_Geographic' name='cbClientReport_Geographic' className='add-only' value='1' />
                            Client has always lived in geographic area or &nbsp;
                            <input type='text' id='txtGeographic' name='txtGeographic' className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbClientReport_Runningaway' name='cbClientReport_Runningaway' className='add-only' value='1' />
                            Client has NO HISTORY of running away
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbClientReport_IssueOther' name='cbClientReport_IssueOther' className='add-only' value='1' />
                            Client has a history of running away or leaving without resolving problems and issues with others
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='small'>(please describe)</span>
                    <textarea id='txtClientReport_IssueOther' name='txtClientReport_IssueOther' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Notes</span>
                    <textarea id='txtNotesClientReport' name='txtNotesClientReport' className='add-only'></textarea>
                </p>
                <p className='w-750'><h2>Family Financial Status</h2></p>

                <p className='w-750'>
                    <span className='eleHeader'>Does client currently work</span>
                    <input type='radio' id='rbCurrentlyWork_Yes' name='rbCurrentlyWork' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbCurrentlyWork_No' name='rbCurrentlyWork' className='add-only' value='No' /> No
                    <textarea id='txtCurrentlyWork' name='txtCurrentlyWork' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Does client receive assistance</span>
                    <input type='radio' id='rbReceiveAssistance_Yes' name='rbReceiveAssistance' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbReceiveAssistance_No' name='rbReceiveAssistance' className='add-only' value='No' /> No
                    <textarea id='txtReceiveAssistance' name='txtReceiveAssistance' className='add-only'></textarea>
                </p>


                <table>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbFinancialdifficulties_Nohistory' name='cbFinancialdifficulties_Nohistory' className='add-only' value='1' />
                            Based on reports and other indicators the client has NO HISTORY of financial difficulties
                        </td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbFinancialdifficulties_ClientReport' name='cbFinancialdifficulties_ClientReport' className='add-only' value='1' />
                            Client reports current financial difficulties
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbFinancialdifficulties_Currentlyunemployed' name='cbFinancialdifficulties_Currentlyunemployed' className='add-only' value='1' />
                            Household provider(s) currently unemployed
                        </td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbFamilyfinancial_PubAssistance' name='cbFamilyfinancial_PubAssistance' className='add-only' value='1' />
                            Family currently receiving public assistance:

                            <table>
                                <tr>
                                    <td className='w-20'></td>
                                    <td className='w-180'>
                                        <input type='checkbox' id='cbFamilyfinancial_FoodStamp' name='cbFamilyfinancial_FoodStamp' className='add-only' value='1' />
                                        food stamp client
                                    </td>
                                    <td className='w-180'>
                                        <input type='checkbox' id='cbFamilyfinancial_AFDC' name='cbFamilyfinancial_AFDC' className='add-only' value='1' />
                                        AFDC
                                    </td>
                                    <td className='w-180'>
                                        <input type='checkbox' id='cbFamilyfinancial_WIC' name='cbFamilyfinancial_WIC' className='add-only' value='1' />
                                        WIC
                                    </td>
                                    <td className='w-180'>
                                        <input type='checkbox' id='cbFamilyfinancial_Disablity' name='cbFamilyfinancial_Disablity' className='add-only' value='1' />
                                        disability
                                    </td>
                                </tr>
                                <tr>
                                    <td className='w-20'></td>
                                    <td className='w-180'>
                                        <input type='checkbox' id='cbFamilyfinancial_Housing' name='cbFamilyfinancial_Housing' className='add-only' value='1' />
                                        Housing
                                    </td>
                                    <td className='w-180'>
                                        <input type='checkbox' id='cbFamilyfinancial_Unemployment' name='cbFamilyfinancial_Unemployment' className='add-only' value='1' />
                                        unemployment
                                    </td>
                                    <td className='w-365'>
                                        <input type='checkbox' id='cbFamilyfinancial_Other' name='cbFamilyfinancial_Other' className='add-only' value='1' />
                                        Other: &nbsp;
                                        <input type='text' id='txtFamilyfinancial_Other' name='txtFamilyfinancial_Other' className='add-only w-250 custom-add-only' />
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCurrentFinaicial' name='cbCurrentFinaicial' className='add-only'
                                value='1' />
                            Current Financial Needs of Person Served/Family: &nbsp;
                            <input type='text' id='txtCurrentFinacial' name='txtCurrentFinacial' className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Notes</span>
                    <textarea id='txtFamilyfinancial_Notes' name='txtFamilyfinancial_Notes' className='add-only'></textarea>
                </p>
                <p className='w-750'><h2>Family Crisis History</h2></p>
                <p className='w-750'>
                    <span className='eleHeader'>Is there any history of crisis in client's family of origin?</span>
                    <input type='radio' id='rbCrisisHistory_Yes' name='rbCrisisHistory' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbCrisisHistory_No' name='rbCrisisHistory' className='add-only' value='No' /> No
                    <span className='small'>Please explain:</span>
                    <textarea id='txtFamilyCrisisHistory' name='txtFamilyCrisisHistory' className='add-only'></textarea>
                </p>
                <span className='eleHeader'>Please select crisis type</span>
                <table>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbCrisis_Housing' name='cbCrisis_Housing' className='add-only' value='1' />
                            Housing
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbCrisis_Accident' name='cbCrisis_Accident' className='add-only' value='1' />
                            Accident
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbCrisis_Illness' name='cbCrisis_Illness' className='add-only' value='1' />
                            Illness
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbCrisis_Financial' name='cbCrisis_Financial' className='add-only' value='1' />
                            Financial
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbCrisis_Legal' name='cbCrisis_Legal' className='add-only' value='1' />
                            Legal
                        </td>
                        <td className='w-560'>
                            <input type='checkbox' id='cbCrisis_Death' name='cbCrisis_Death' className='add-only' value='1' />
                            Death(s) of parent(s), sibling(s), grandparent(s), other close relative(s), friend(s)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCrisis_Other' name='cbCrisis_Other' className='add-only' value='1' />
                            Other: &nbsp;
                            <input type='text' id='txtCrisis_Other' name='txtCrisis_Other' className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Was client directly or vicariously involved in crisis</span>
                    <span className='small'>Please explain:</span>
                    <textarea id='txtVicariouslyCrisis' name='txtVicariouslyCrisis' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Notes</span>
                    <textarea id='txtNotes_Crisis' name='txtNotes_Crisis' className='add-only'></textarea>
                </p>
                <p className='w-750'><h2>Parenting Dynamics/Discipline</h2></p>
                <span className='small'>(if Client has children)</span>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Does client interact with his/her children on a daily basis</span>
                            <input type='radio' id='rbDailyBasis_Yes' name='rbDailyBasis' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbDailyBasis_No' name='rbDailyBasis' className='add-only' value='No' /> No
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Does client behaviors effect parenting skills</span>
                            <input type='radio' id='rbEffectParenting_Yes' name='rbEffectParenting' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbEffectParenting_No' name='rbEffectParenting' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Does client set a positive example</span>
                            <input type='radio' id='rbPositiveExample_Yes' name='rbPositiveExample' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbPositiveExample_No' name='rbPositiveExample' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbNoProblem' name='cbNoProblem' className='add-only' value='1' />
                            No problems with parenting issues reported
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbParentingdynamics_HouseholdRules' name='cbParentingdynamics_HouseholdRules' className='add-only' value='1' />
                            Conflicts over household rules
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Parent(s)/ states</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbParentingdynamics_Childrenbehaviour' name='cbParentingdynamics_Childrenbehaviour' className='add-only' value='1' />
                            Cannot control his/her children's behavior
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbParentingdynamics_LackLimit' name='cbParentingdynamics_LackLimit' className='add-only' value='1' />
                            Lacks limits or rules regarding his/her children's behavior
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbParentingdynamics_ChildrenFree' name='cbParentingdynamics_ChildrenFree' className='add-only' value='1' />
                            Cannot state where his/her children's spend free time
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbParentingdynamics_ChildrenFreeTimeWhom' name='cbParentingdynamics_ChildrenFreeTimeWhom' className='add-only' value='1' />
                            Cannot state with whom his/her children's spend free time
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbParentingdynamics_ProblemSchool' name='cbParentingdynamics_ProblemSchool' className='add-only' value='1' />
                            Not aware of his/her children's problems in school
                        </td>
                    </tr>


                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbParentingdynamics_NonParent' name='cbParentingdynamics_NonParent' className='add-only' value='1' />
                            Non-parent/guardian involved in parenting/discipline when client was a child
                        </td>
                    </tr>
                </table>


                <p className='w-750'>
                    <span className='eleHeader'>Notes</span>
                    <textarea id='txtNotes_Parentingdynamics' name='txtNotes_Parentingdynamics' className='add-only'></textarea>
                </p>


                <p className='w-750'><h2>Family Relationships</h2></p>


                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Does client behaviors effect his/her relationship with family members</span>
                            <input type='radio' id='rbBehaviors_Yes' name='rbBehaviors' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbBehaviors_No' name='rbBehaviors' className='add-only' value='No' /> No
                        </td>
                    </tr>


                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Does client have a difficult time interacting with family</span>
                            <input type='radio' id='rbDifficultTime_Yes' name='rbDifficultTime' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbDifficultTime_No' name='rbDifficultTime' className='add-only' value='No' /> No
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>If yes, who</span>
                            <input type='text' id='txtIfYesWho' name='txtIfYesWho' className='add-only' />
                        </td>
                    </tr>
                </table>


                <table>
                    <tr>
                        <td>
                            <input type='checkbox' id='cbFR_ClientReports' name='cbFR_ClientReports' className='add-only' value='1' />
                            Client reports negative relationship(s) with:

                            <table>
                                <tr>
                                    <td className='w-20'></td>
                                    <td className='w-187'>
                                        <input type='checkbox' id='cbFR_Father' name='cbFR_Father' className='add-only' value='1' />
                                        Father
                                    </td>
                                    <td className='w-187'>
                                        <input type='checkbox' id='cbFR_Mother' name='cbFR_Mother' className='add-only' value='1' />
                                        Mother
                                    </td>
                                    <td className='w-187'>
                                        <input type='checkbox' id='cbFR_Parent' name='cbFR_Parent' className='add-only' value='1' />
                                        Parent
                                    </td>
                                    <td className='w-187'>
                                        <input type='checkbox' id='cbFR_Children' name='cbFR_Children' className='add-only' value='1' />
                                        Children
                                    </td>
                                </tr>
                                <tr>
                                    <td className='w-20'></td>
                                    <td className='w-187'>
                                        <input type='checkbox' id='cbFR_Grandfather' name='cbFR_Grandfather' className='add-only' value='1' />
                                        Grandfather
                                    </td>
                                    <td className='w-187'>
                                        <input type='checkbox' id='cbFR_Grandmother' name='cbFR_Grandmother' className='add-only' value='1' />
                                        Grandmother
                                    </td>
                                    <td className='w-187'>
                                        <input type='checkbox' id='cbFR_Aunt' name='cbFR_Aunt' className='add-only' value='1' />
                                        Aunt
                                    </td>
                                    <td className='w-187'>
                                        <input type='checkbox' id='cbFR_Uncle' name='cbFR_Uncle' className='add-only' value='1' />
                                        Uncle
                                    </td>
                                </tr>
                                <tr>
                                    <td className='w-20'></td>
                                    <td className='w-187'>
                                        <input type='checkbox' id='cbFR_Sibling' name='cbFR_Sibling' className='add-only' value='1' />
                                        Sibling(s)
                                    </td>
                                    <td className='w-187'>
                                        <input type='checkbox' id='cbFR_Stepsibling' name='cbFR_Stepsibling' className='add-only' value='1' />
                                        Stepsibling(s)
                                    </td>
                                    
                                </tr>
                                <tr>
                                    <td className='w-20'></td>
                                    <td className='w-750'>
                                        <input type='checkbox' id='cbFR_Other' name='cbFR_Other' className='add-only' value='1' />
                                        Other: &nbsp;
                                        <input type='text' id='txtFR_Other' name='txtFR_Other' className='add-only w-250 custom-add-only' />
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbFR_ClientReportsPositive' name='cbFR_ClientReportsPositive' className='add-only' value='1' />
                            Client reports positive relationship(s) with:

                            <table>
                                <tr>
                                    <td className='w-20'></td>
                                    <td className='w-187'>
                                        <input type='checkbox' id='cbFR_2_Father' name='cbFR_2_Father' className='add-only' value='1' />
                                        Father
                                    </td>
                                    <td className='w-187'>
                                        <input type='checkbox' id='cbFR_2_Mother' name='cbFR_2_Mother' className='add-only' value='1' />
                                        Mother
                                    </td>
                                    <td className='w-187'>
                                        <input type='checkbox' id='cbFR_2_Parent' name='cbFR_2_Parent' className='add-only' value='1' />
                                        Parent
                                    </td>
                                    <td className='w-187'>
                                        <input type='checkbox' id='cbFR_2_Children' name='cbFR_2_Children'
                                            className='add-only' value='1' />
                                        Children
                                    </td>
                                </tr>
                                <tr>
                                    <td className='w-20'></td>
                                    <td className='w-187'>
                                        <input type='checkbox' id='cbFR_2_Grandfather' name='cbFR_2_Grandfather' className='add-only' value='1' />
                                        Grandfather
                                    </td>
                                    <td className='w-187'>
                                        <input type='checkbox' id='cbFR_2_Grandmother' name='cbFR_2_Grandmother' className='add-only' value='1' />
                                        Grandmother
                                    </td>
                                    <td className='w-187'>
                                        <input type='checkbox' id='cbFR_2_Aunt' name='cbFR_2_Aunt' className='add-only' value='1' />
                                        Aunt
                                    </td>
                                    <td className='w-187'>
                                        <input type='checkbox' id='cbFR_2_Uncle' name='cbFR_2_Uncle' className='add-only' value='1' />
                                        Uncle
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <input type='checkbox' id='cbFR_ClientFamilyReports' name='cbFR_ClientFamilyReports' className='add-only' value='1' />
                            Client/family reports negative family relationship between (Please explain)
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='small'>(Please explain):</span>
                    <textarea id='txtFamilyRelations' name='txtFamilyRelations' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Notes</span>
                    <textarea id='txtNotes_FamilyRelations' name='txtNotes_FamilyRelations' className='add-only'></textarea>
                </p>
                <p className='w-750'><h2>Social Relationships/ Social Supports</h2></p>
                <p className='w-750'>
                    <span className='eleHeader'>Describe the individual's ability to relate to others
                    </span>
                    <span className='small'>(include family, peers, authority figures):</span>
                    <textarea id='txtSocialRelations' name='txtSocialRelations' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Describe the individual's environmental support system
                    </span>
                    <span className='small'>(e.g., participation in social groups, community/ recreational activities, etc.):</span>
                    <textarea id='txtSupportSystem' name='txtSupportSystem' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Client reports having approximately Friends</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbClientReports_0' name='cbClientReports_0' className='add-only' value='1' />
                            0
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbClientReports_1to5' name='cbClientReports_1to5' className='add-only' value='1' />
                            1-5
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbClientReports_6to15' name='cbClientReports_6to15' className='add-only' value='1' />
                            6-15
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbClientReports_16to30' name='cbClientReports_16to30' className='add-only' value='1' />
                            16-30
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbClientReports_31to60' name='cbClientReports_31to60' className='add-only' value='1' />
                            31-60
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbClientReports_61Friends' name='cbClientReports_61Friends' className='add-only' value='1' />
                            61
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Client reports having approximately Close Friends</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbClientReports_2_0' name='cbClientReports_2_0' className='add-only' value='1' />
                            1
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbClientReports_1' name='cbClientReports_1' className='add-only' value='1' />
                            1
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbClientReports_2to3' name='cbClientReports_2to3' className='add-only' value='1' />
                            2-3
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbClientReports_4to6' name='cbClientReports_4to6' className='add-only' value='1' />
                            4-6
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbClientReports_7to9' name='cbClientReports_7to9' className='add-only' value='1' />
                            7-9
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbClientReports_10Friends' name='cbClientReports_10Friends' className='add-only' value='1' />
                            10
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbClientReports_CurrentWith' name='cbClientReports_CurrentWith' className='add-only' value='1' />
                            Client currently romantically involved with a &nbsp;
                            <input type='radio' id='rbRomantically_Boyfriend' name='rbRomantically' className='add-only' value='Boyfriend' /> &nbsp;
                            Boyfriend &nbsp;
                            <input type='radio' id='rbRomantically_Girlfriend' name='rbRomantically' className='add-only' value='Girlfriend' /> &nbsp;
                            Girlfriend &nbsp;
                            <input type='radio' id='rbRomantically_Other' name='rbRomantically' className='add-only' value='SignificantOther' /> &nbsp;
                            Significant Other: &nbsp;
                            <input type='text' id='txtRomantically_Other' name='txtRomantically_Other' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Describe in client words, their current support system or needs in that area
                    </span>
                    <textarea id='txtNeedsThatArea' name='txtNeedsThatArea' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>How does the individual generally get along with other people?</span>
                            <span className='small'>(check all that apply)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbIndividual_Affectionate' name='cbIndividual_Affectionate' className='add-only' value='1' />
                            Affectionate
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbIndividual_Shy' name='cbIndividual_Shy' className='add-only' value='1' />
                            Shy/Withdrawn
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbIndividual_Submissive' name='cbIndividual_Submissive' className='add-only' value='1' />
                            Submissive
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbIndividual_Aggressive' name='cbIndividual_Aggressive' className='add-only' value='1' />
                            Aggressive
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbIndividual_Friendly' name='cbIndividual_Friendly' className='add-only' value='1' />
                            Friendly
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbIndividual_Follower' name='cbIndividual_Follower' className='add-only' value='1' />
                            Follower
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbIndividual_Avoidant' name='cbIndividual_Avoidant' className='add-only' value='1' />
                            Avoidant
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbIndividual_Argues' name='cbIndividual_Argues' className='add-only' value='1' />
                            Argues often
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbIndividual_Leader' name='cbIndividual_Leader' className='add-only' value='1' />
                            Leader
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbIndividual_Dependent' name='cbIndividual_Dependent' className='add-only' value='1' />
                            Dependent
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbIndividual_Outgoing' name='cbIndividual_Outgoing' className='add-only' value='1' />
                            Outgoing
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbIndividual_Fights' name='cbIndividual_Fights' className='add-only' value='1' />
                            Fights
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Notes</span>
                    <textarea id='txtNotes_Individual' name='txtNotes_Individual' className='add-only'></textarea>
                </p>
                <p className='w-750'><h2>Legal History And Current Legal Status</h2></p>
                <p className='w-750'>
                    <span className='eleHeader'>Is the client currently on probation or involved in a current criminal case?</span>
                    <input type='radio' id='rbCriminalCase_Yes' name='rbCriminalCase' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbCriminalCase_no' name='rbCriminalCase' className='add-only' value='No' /> No
                    <span className='small'>Please explain:</span>
                    <textarea id='txtCriminalCase' name='txtCriminalCase' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Has client recently committed a crime that he/she could be arrested for</span>
                    <input type='radio' id='rbArrested_Yes' name='rbArrested' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbArrested_No' name='rbArrested' className='add-only' value='No' /> No
                    <span className='small'>Please explain:</span>
                    <textarea id='txtArrested' name='txtArrested' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbLH_CriminalRecord' name='cbLH_CriminalRecord' className='add-only' value='1' />
                            Client has a criminal record
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbLH_Neighbours' name='cbLH_Neighbours' className='add-only' value='1' />
                            Client has repeatedly stolen from the family, house or neighbors
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbLH_Offenses' name='cbLH_Offenses' className='add-only' value='1' />
                            Client has been charged with burglary-related offenses
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbLH_Adjudications' name='cbLH_Adjudications' className='add-only' value='1' />
                            Client has no history of arrests, delinquency referrals, or adjudications
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Has anyone in client's family of origin ever been arrested</span>
                            <input type='radio' id='rbArrested_1_Yes' name='rbArrested_1' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbArrested_1_No' name='rbArrested_1' className='add-only' value='No' /> No
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>If, yes, who?</span>
                            <input type='text' id='txtArrested_Who' name='txtArrested_Who' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbLH_LegalInvolvment' name='cbLH_LegalInvolvment' className='add-only' value='1' />
                            According to reports, there is  not and has never been legal involvement in client's family of origin
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbLH_Jail' name='cbLH_Jail' className='add-only' value='1' />
                            Parent, guardian or sibling has history of incarceration in jail or prison
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbLH_Probation' name='cbLH_Probation' className='add-only' value='1' />
                            Parent, guardian or sibling Is or has been on probation
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Notes</span>
                    <textarea id='txtNotes_LegalHistory' name='txtNotes_LegalHistory' className='add-only'></textarea>
                </p>
                <p className='w-750'><h2>Educational/ Vocational History</h2></p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Educational- highest level achieved</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbEducational_GradeSchool' name='cbEducational_GradeSchool' className='add-only' value='1' />
                            Grade School (K-5)
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbEducational_MiddleSchool' name='cbEducational_MiddleSchool' className='add-only' value='1' />
                            Middle School
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbEducational_HighSchool' name='cbEducational_HighSchool' className='add-only' value='1' />
                            High School, no diploma
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbEducational_Diploma' name='cbEducational_Diploma' className='add-only' value='1' />
                            Diploma/GED
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbEducational_SomeCollege' name='cbEducational_SomeCollege' className='add-only' value='1' />
                            Some College or technical school
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbEducational_2Year' name='cbEducational_2Year' className='add-only' value='1' />
                            2-year college, Associate's Degree
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbEducational_4Year' name='cbEducational_4Year' className='add-only' value='1' />
                            4-year college, Bachelor's Degree
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbEducational_Graduate' name='cbEducational_Graduate' className='add-only' value='1' />
                            Graduate work, no degree
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbEducational_Professional' name='cbEducational_Professional' className='add-only' value='1' />
                            Professional degree or more
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>List Highest Grade Completed</span>
                    <textarea id='txtEducational_Highest' name='txtEducational_Highest' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Educational -current enrollment</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbEducationalC_None' name='cbEducationalC_None' className='add-only' value='1' />
                            None
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbEducationalC_Alternative' name='cbEducationalC_Alternative' className='add-only' value='1' />
                            Alternative Learning
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbEducationalC_Academic' name='cbEducationalC_Academic' className='add-only' value='1' />Academic School (K-12)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbEducationalC_Vocational' name='cbEducationalC_Vocational' className='add-only' value='1' />
                            Vocational or Technical School
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbEducationalC_College' name='cbEducationalC_College' className='add-only' value='1' />
                            College
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbEducationalC_GED' name='cbEducationalC_GED' className='add-only' value='1' />
                            GED Program
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Previous Literacy Level</span>
                            <input type='text' id='txtPreviousLiteracyLevel' name='txtPreviousLiteracyLevel' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Current Literacy Level</span>
                            <input type='text' id='txtCurrentLiteracyLevel' name='txtCurrentLiteracyLevel' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Need for Assistive Technology</span>
                            <input type='radio' id='rbNeedAssistive_Yes' name='rbNeedAssistive' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbNeedAssistive_No' name='rbNeedAssistive' className='add-only' value='No' /> No
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Occupational</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbOccupational_FullTime' name='cbOccupational_FullTime' className='add-only' value='1' />
                            Full-time work (35 hours/week)
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbOccupational_PartTime' name='cbOccupational_PartTime' className='add-only' value='1' />
                            Part-time work (less than 35 hours/week)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbOccupational_Seeking' name='cbOccupational_Seeking' className='add-only' value='1' />
                            Unemployed and seeking employment
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbOccupational_NotSeeking' name='cbOccupational_NotSeeking' className='add-only' value='1' />
                            Unemployed - NOT seeking employment
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Not in labor force and not seeking due to</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cblabor_Homemaker' name='cblabor_Homemaker' className='add-only' value='1' />
                            Homemaker
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cblabor_Student' name='cblabor_Student' className='add-only' value='1' />
                            Student
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cblabor_Retired' name='cblabor_Retired' className='add-only' value='1' />
                            Retired
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cblabor_Received' name='cblabor_Received' className='add-only' value='1' />
                            Received
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cblabor_Incarcerated' name='cblabor_Incarcerated' className='add-only' value='1' />
                            Incarcerated
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cblabor_Court' name='cblabor_Court' className='add-only' value='1' />
                            Court-ordered community service
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cblabor_Structured' name='cblabor_Structured' className='add-only' value='1' />
                            Structured Day Activity
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cblabor_Unpaid' name='cblabor_Unpaid' className='add-only' value='1' />
                            Unpaid Vocational Rehabilitation
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cblabor_Volunteer' name='cblabor_Volunteer' className='add-only' value='1' />
                            Volunteer
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbInstitutionalized' name='cbInstitutionalized' className='add-only' value='1' />
                            Institutionalized
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cblabor_None' name='cblabor_None' className='add-only' value='1' />
                            None
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Notes</span>
                    <textarea id='txtNotes_Educational' name='txtNotes_Educational' className='add-only'></textarea>
                </p>
                <p className='w-750'><h2>Abuse/ Neglect/ Domestic Violence/ Agression/ Trauma History</h2></p>
                <p className='w-750'>
                    <span className='eleHeader'>Has client witnessed any violence/abuse/neglect</span>
                    <input type='radio' id='rbVoilence_Yes' name='rbVoilence' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbVoilence_No' name='rbVoilence' className='add-only' value='No' /> No
                    <span className='small'>Please explain:</span>
                    <textarea id='txtVoilence' name='txtVoilence' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Has client experienced any physical/ emotional/ sexual abuse or neglect</span>
                    <input type='radio' id='rbEmotional_Yes' name='rbEmotional' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbEmotional_No' name='rbEmotional' className='add-only' value='No' /> No
                    <span className='small'>Please explain:</span>
                    <textarea id='txtEmotional' name='txtEmotional' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Has the client witnessed/experienced a traumatic event/ circumstance</span>
                    <input type='radio' id='rbWitnessed_Yes' name='rbWitnessed' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbWitnessed_No' name='rbWitnessed' className='add-only' value='No' /> No
                    <span className='small'>Please explain:</span>
                    <textarea id='txtWitnessed' name='txtWitnessed' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Does client behaviors often lead to violence</span>
                            <input type='radio' id='rbViolence_Yes' name='rbViolence' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbViolence_No' name='rbViolence' className='add-only' value='No' /> No
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>If yes, towards who</span>
                            <input type='text' id='txtVoilence_Who' name='txtVoilence_Who' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Does the client have a history of trauma not including abuse, neglect, domestic violence, or anger/aggression?</span>
                    <input type='radio' id='rbAnger_Yes' name='rbAnger' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbAnger_No' name='rbAnger' className='add-only' value='No' /> No
                    <span className='small'>Please explain:</span>
                    <textarea id='txtAnger' name='txtAnger' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbTrauma_AbuseFamily' name='cbTrauma_AbuseFamily' className='add-only' value='1' />
                            According to reports, there is NO HISTORY of violence or abuse in the family
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <input type='checkbox' id='cbTrauma_Violence' name='cbTrauma_Violence' className='add-only' value='1' />
                            Reported history/incidence of domestic violence
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <input type='checkbox' id='cbTrauma_Agression' name='cbTrauma_Agression' className='add-only' value='1' />
                            Client has reported history of anger/aggression problems
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <input type='checkbox' id='cbTrauma_NoHistoryDCF' name='cbTrauma_NoHistoryDCF' className='add-only' value='1' />
                            According to reports the family has NO HISTORY of DCF involvement
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <input type='checkbox' id='cbTrauma_DCf' name='cbTrauma_DCf' className='add-only' value='1' />
                            Family had prior or current DCF involvement
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <input type='checkbox' id='cbTrauma_Investigated' name='cbTrauma_Investigated' className='add-only' value='1' />
                            Family was previously investigated for abuse, neglect, or abandonment-deemed: &nbsp;
                            <input type='radio' id='rbDeemed_Founded' name='rbDeemed' className='add-only' value='Founded' /> &nbsp;
                            Founded &nbsp;
                            <input type='radio' id='rbDeemed_UnFounded' name='rbDeemed' className='add-only' value='Unfounded' /> &nbsp;
                            Unfounded

                        </td>
                    </tr>
                    <tr>
                        <td>
                            <input type='checkbox' id='cbTrauma_Allegations' name='cbTrauma_Allegations' className='add-only' value='1' />
                            Present allegations of abuse/neglect
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <input type='checkbox' id='cbTrauma_Hotline' name='cbTrauma_Hotline' className='add-only' value='1' />
                            Reported to hotline by current counselor/case manager: &nbsp;
                            <input type='radio' id='rbTrauma_Accepted' name='rbHotline' className='add-only' value='Accepted' /> &nbsp;
                            Accepted &nbsp;
                            <input type='radio' id='rbTrauma_NotAccepted' name='rbHotline' className='add-only' value='Not Accepted' /> &nbsp;
                            Not Accepted
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <input type='checkbox' id='cbTrauma_CaseManager' name='cbTrauma_CaseManager' className='add-only' value='1' />
                            Not reported by current counselor/case manager due to: &nbsp;
                            <input type='text' id='txtTraumaCaseManager' name='txtTraumaCaseManager' className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <input type='checkbox' id='cbTrauma_Sexual' name='cbTrauma_Sexual' className='add-only' value='1' />
                            Documented instances of child abuse (physical, emotional or sexual) or neglect
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <input type='checkbox' id='cbTrauma_PhysicalEvidence' name='cbTrauma_PhysicalEvidence' className='add-only' value='1' />
                            Physical evidence of abuse or neglect on the Person served
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Notes</span>
                    <textarea id='txtNotes_Trauma' name='txtNotes_Trauma' className='add-only'></textarea>
                </p>
                <p className='w-750'><h2>Developmental & Medical History/ Insurance Information</h2></p>
                <p className='w-750'>
                    <span className='eleHeader'>According to reports, was client exposed to any alcohol, prescription drugs, elicit drugs, over the counter remedies, or any other teratogenic agents while in utero?</span>
                    <input type='radio' id='rbUtero_Yes' name='rbUtero' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbUtero_No' name='rbUtero' className='add-only' value='No' /> No
                    <span className='small'>If yes, please explain:</span>
                    <textarea id='txtUtero' name='txtUtero' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Is there anyone in clients family of origin (parents/children) who suffers from developmental problems</span>
                    <input type='radio' id='rbClientsFamily_Yes' name='rbClientsFamily' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbClientsFamily_No' name='rbClientsFamily' className='add-only' value='No' /> No
                    <span className='small'>If yes, please explain:</span>
                    <textarea id='txtClientsFamily' name='txtClientsFamily' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Are Client's immunizations current?</span>
                    <input type='radio' id='rbClientCurrent_Yes' name='rbClientCurrent' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbClientCurrent_No' name='rbClientCurrent' className='add-only' value='No' /> No
                    <span className='small'>If yes, please explain:</span>
                    <textarea id='txtClientCurrent' name='txtClientCurrent' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Is there anyone in clients family (parents) that have a history of medical problems</span>
                    <input type='radio' id='rbMedicalProblem_Yes' name='rbMedicalProblem' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbMedicalProblem_No' name='rbMedicalProblem' className='add-only' value='No' /> No
                    <span className='small'>If yes, please explain:</span>
                    <textarea id='txtMedicalProblem' name='txtMedicalProblem' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbMH_Difficults' name='cbMH_Difficults' className='add-only' value='1' />
                            Client has NO HISTORY of developmental delays, severe accidents, or medical difficulties
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <input type='checkbox' id='cbMH_PersonServed' name='cbMH_PersonServed' className='add-only' value='1' />
                            Problems during the pregnancy and/or delivery of the person served
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <input type='checkbox' id='cbMH_Childhood' name='cbMH_Childhood' className='add-only' value='1' />
                            Client exhibited developmental problems/delays during childhood:
                            <input type='text' id='txtChildHood' name='txtChildHood' className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <input type='checkbox' id='cbMH_Client1' name='cbMH_Client1' className='add-only' value='1' />
                            Client: &nbsp;
                            <input type='radio' id='rbClient1_MayBePregnant' name='rbClient1' className='add-only' value='MayBePregnant' /> &nbsp;
                            may be pregnant &nbsp;
                            <input type='radio' id='rbClient1_IsPregnant' name='rbClient1' className='add-only' value='IsPregnant' /> &nbsp;
                            is pregnant &nbsp;
                            <input type='radio' id='rbClient1_HasBeenPregnant' name='rbClient1' className='add-only' value='HasBeenPregnant' /> &nbsp;
                            has been pregnant &nbsp;
                            <input type='radio' id='rbClient1_BirthedChild' name='rbClient1' className='add-only' value='HasBirthedChild' /> &nbsp;
                            has birthed a child
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <input type='checkbox' id='cbMH_Client2' name='cbMH_Client2' className='add-only' value='1' />
                            Client: &nbsp;
                            <input type='radio' id='rbClient2_HasImpregnated' name='rbClient2' className='add-only' value='MayHaveImpregnatedFemale' /> &nbsp;
                            may have impregnated a female &nbsp;
                            <input type='radio' id='rbClient2_HaveImpregnated' name='rbClient2' className='add-only' value='HasImpregnatedFemale' /> &nbsp;
                            has impregnated a female &nbsp;
                            <input type='radio' id='rbClient2_HasFathered' name='rbClient2' className='add-only' value='HasFatheredChild' /> &nbsp;
                            has fathered a child
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <input type='checkbox' id='cbMH_HeadInjuries' name='cbMH_HeadInjuries' className='add-only' value='1' />
                            Client has history of one or more serious head injuries
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <input type='checkbox' id='cbMH_MedicalHistory' name='cbMH_MedicalHistory' className='add-only' value='1' />
                    Client has a history of medical/developmental problems
                    <span className='small'>(specify):</span>
                    <textarea id='txtMH_MedicalHistory' name='txtMH_MedicalHistory' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <input type='checkbox' id='cbMH_Medicalcondition' name='cbMH_Medicalcondition' className='add-only' value='1' />
                    Client currently taking medication for medical condition
                    <span className='small'>(specify):</span>
                    <textarea id='txtMH_MedicalCondition' name='txtMH_MedicalCondition' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <input type='checkbox' id='cbMH_MajorAccidents' name='cbMH_MajorAccidents' className='add-only' value='1' />
                    Client has history of one or more major accidents
                    <span className='small'>(specify):</span>
                    <textarea id='txtMH_MajorAccidents' name='txtMH_MajorAccidents' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Does Client have active health insurance?</span>
                            <input type='radio' id='rbHealthInsurance_Yes' name='rbHealthInsurance' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbHealthInsurance_No' name='rbHealthInsurance' className='add-only' value='No' /> No
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>If yes, company and ID#</span>
                            <input type='text' id='txtHealthInsurance_ID' name='txtHealthInsurance_ID' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Primary Care Physician Name/Phone
                            </span>
                            <input type='text' id='txtMH_PhysicianName' name='txtMH_PhysicianName' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Dentist Name/Phone
                            </span>
                            <input type='text' id='txtMH_DentistName' name='txtMH_DentistName' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Notes</span>
                    <textarea id='txtNotes_MedicalHistory' name='txtNotes_MedicalHistory' className='add-only'></textarea>
                </p>
                <p className='w-750'><h2>Psychiatric/Counseling History</h2></p>
                <table>
                    <tr>
                        <td className='w-500'>
                            <span className='eleHeader'>Is client currently or has client ever received psychiatric/ counseling services</span>
                            <input type='radio' id='rbCounselingServices_Yes' name='rbCounselingServices' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbCounselingServices_No' name='rbCounselingServices' className='add-only' value='No' /> No
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>If yes, from who</span>
                            <input type='text' id='txtCounselingServices' name='txtCounselingServices' className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Has client ever been diagnosed</span>
                            <input type='radio' id='rbClientDiagnosed_Yes' name='rbClientDiagnosed' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbClientDiagnosed_No' name='rbClientDiagnosed' className='add-only' value='No' /> No
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>If yes, by who</span>
                            <input type='text' id='txtClientDianosed' name='txtClientDianosed' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Diagnosis</span>
                            <input type='text' id='txtDiagnosis' name='txtDiagnosis' className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCH_FamilyReports' name='cbCH_FamilyReports' className='add-only' value='1' />
                            Family reports NO HISTORY of psychiatric/counseling services
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <input type='checkbox' id='cbCH_Hospitalization' name='cbCH_Hospitalization' className='add-only' value='1' />
                            Client reports history of hospitalization or other treatment for psychiatric problems

                            <table>
                                <tr>
                                    <td className='w-20'></td>
                                    <td className='w-400'>Location(s)/ Provider(s): &nbsp;
                                        <input type='text' id='txtCh_Location' name='txtCh_Location' className='add-only w-200 custom-add-only' />
                                    </td>
                                    <td className='w-330'>Date(s): &nbsp;
                                        <input type='date' id='txtCh_Date' name='txtCh_Date' className='add-only w-200 custom-add-only' />
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <input type='checkbox' id='cbCH_PsychiatricConditions' name='cbCH_PsychiatricConditions' className='add-only' value='1' />
                            Client reports current or past prescriptions for psychiatric condition(s): &nbsp;
                            <input type='radio' id='rbPsychiatricConditions_Yes' name='rbPsychiatricConditions' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbPsychiatricConditions_No' name='rbPsychiatricConditions' className='add-only' value='No' /> No
                            <span className='small'>*If yes, please fill out the following chart and obtain a Private Health Information (PHI) Consent for Release Form.</span>
                        </td>
                    </tr>
                </table>

                <p className='w-750'><h3>Current Medications</h3></p>
                <p className='w-750'><h4>Med #1</h4></p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Medication</span>
                            <input type='text' id='txtMeds_1_1' name='txtMeds_1_1' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Dosage</span>
                            <input type='text' id='txtMeds_1_2' name='txtMeds_1_2' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Prescribed By</span>
                            <input type='text' id='txtMeds_1_3' name='txtMeds_1_3' className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Compliant?</span>
                            <input type='text' id='txtMeds_1_4' name='txtMeds_1_4' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Efficacy</span>
                            <input type='text' id='txtMeds_1_5' name='txtMeds_1_5' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Side Effects</span>
                            <input type='text' id='txtMeds_1_6' name='txtMeds_1_6' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Current Regimen</span>
                            <input type='text' id='txtMeds_1_7' name='txtMeds_1_7' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'># of Months on Med</span>
                            <input type='text' id='txtMeds_1_8' name='txtMeds_1_8' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'><h4>Med #2</h4></p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Medication</span>
                            <input type='text' id='txtMeds_2_1' name='txtMeds_2_1' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Dosage</span>
                            <input type='text' id='txtMeds_2_2' name='txtMeds_2_2' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Prescribed By</span>
                            <input type='text' id='txtMeds_2_3' name='txtMeds_2_3' className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Compliant?</span>
                            <input type='text' id='txtMeds_2_4' name='txtMeds_2_4' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Efficacy</span>
                            <input type='text' id='txtMeds_2_5' name='txtMeds_2_5' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Side Effects</span>
                            <input type='text' id='txtMeds_2_6' name='txtMeds_2_6' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Current Regimen</span>
                            <input type='text' id='txtMeds_2_7' name='txtMeds_2_7' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'># of Months on Med</span>
                            <input type='text' id='txtMeds_2_8' name='txtMeds_2_8' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'><h4>Med #3</h4></p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Medication</span>
                            <input type='text' id='txtMeds_3_1' name='txtMeds_3_1' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Dosage</span>
                            <input type='text' id='txtMeds_3_2' name='txtMeds_3_2' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Prescribed By</span>
                            <input type='text' id='txtMeds_3_3' name='txtMeds_3_3' className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Compliant?</span>
                            <input type='text' id='txtMeds_3_4' name='txtMeds_3_4' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Efficacy</span>
                            <input type='text' id='txtMeds_3_5' name='txtMeds_3_5' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Side Effects</span>
                            <input type='text' id='txtMeds_3_6' name='txtMeds_3_6' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Current Regimen</span>
                            <input type='text' id='txtMeds_3_7' name='txtMeds_3_7' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'># of Months on Med</span>
                            <input type='text' id='txtMeds_3_8' name='txtMeds_3_8' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'><h4>Med #4</h4></p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Medication</span>
                            <input type='text' id='txtMeds_4_1' name='txtMeds_4_1' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Dosage</span>
                            <input type='text' id='txtMeds_4_2' name='txtMeds_4_2' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Prescribed By</span>
                            <input type='text' id='txtMeds_4_3' name='txtMeds_4_3' className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Compliant?</span>
                            <input type='text' id='txtMeds_4_4' name='txtMeds_4_4' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Efficacy</span>
                            <input type='text' id='txtMeds_4_5' name='txtMeds_4_5' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Side Effects</span>
                            <input type='text' id='txtMeds_4_6' name='txtMeds_4_6' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Current Regimen</span>
                            <input type='text' id='txtMeds_4_7' name='txtMeds_4_7' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'># of Months on Med</span>
                            <input type='text' id='txtMeds_4_8' name='txtMeds_4_8' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'><h4>Med #5</h4></p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Medication</span>
                            <input type='text' id='txtMeds_5_1' name='txtMeds_5_1' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Dosage</span>
                            <input type='text' id='txtMeds_5_2' name='txtMeds_5_2' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Prescribed By</span>
                            <input type='text' id='txtMeds_5_3' name='txtMeds_5_3' className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Compliant?</span>
                            <input type='text' id='txtMeds_5_4' name='txtMeds_5_4' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Efficacy</span>
                            <input type='text' id='txtMeds_5_5' name='txtMeds_5_5' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Side Effects</span>
                            <input type='text' id='txtMeds_5_6' name='txtMeds_5_6' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Current Regimen</span>
                            <input type='text' id='txtMeds_5_7' name='txtMeds_5_7' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'># of Months on Med</span>
                            <input type='text' id='txtMeds_5_8' name='txtMeds_5_8' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'><h4>Med #6</h4></p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Medication</span>
                            <input type='text' id='txtMeds_6_1' name='txtMeds_6_1' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Dosage</span>
                            <input type='text' id='txtMeds_6_2' name='txtMeds_6_2' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Prescribed By</span>
                            <input type='text' id='txtMeds_6_3' name='txtMeds_6_3' className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Compliant?</span>
                            <input type='text' id='txtMeds_6_4' name='txtMeds_6_4' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Efficacy</span>
                            <input type='text' id='txtMeds_6_5' name='txtMeds_6_5' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Side Effects</span>
                            <input type='text' id='txtMeds_6_6' name='txtMeds_6_6' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Current Regimen</span>
                            <input type='text' id='txtMeds_6_7' name='txtMeds_6_7' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'># of Months on Med</span>
                            <input type='text' id='txtMeds_6_8' name='txtMeds_6_8' className='add-only' />
                        </td>
                    </tr>
                </table>


                <p className='w-750'>
                    <input type='checkbox' id='cbCH_Mental' name='cbCH_Mental' className='add-only' value='1' />
                    Family of origin history of mental illness:
                    <span className='small'>(Please describe):</span>
                    <textarea id='txtCH_Mental' name='txtCH_Mental' className='add-only'></textarea>
                </p>


                <p className='w-750'>
                    <span className='eleHeader'>Notes</span>
                    <textarea id='txtNotes_CounslingHistory' name='txtNotes_CounslingHistory' className='add-only'></textarea>
                </p>


                <p className='w-750'><h2>Sexual Orientation/Gender Identity & Expression/Sexual History</h2>
                    <span className='small'>(This section may be skipped depending on the age and maturity of the client)</span></p>



                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Sexual orientation</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbHeterosexual' name='rbSexual' className='add-only' value='Heterosexual' /> Heterosexual
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbHomosexual' name='rbSexual' className='add-only' value='Homosexual' /> Homosexual
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbBisexual' name='rbSexual' className='add-only' value='Bisexual' /> Bisexual
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbAsexual' name='rbSexual' className='add-only' value='Asexual' /> Asexual
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbPansexual' name='rbSexual' className='add-only' value='Pansexual' /> Pansexual
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbQuestioning' name='rbSexual' className='add-only' value='Questioning' /> Questioning
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbPrefers' name='rbSexual' className='add-only' value='PrefersNotToAnswerThisQuestion' /> Prefers not to answer this question
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Gender identity</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbTransgender' name='rbGender' className='add-only' value='Transgender' /> Transgender
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbGenderNeutral' name='rbGender' className='add-only' value='GenderNeutral' /> Gender Neutral/Fluid
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbHe' name='rbGender' className='add-only' value='He' /> He/Him/His
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbShe' name='rbGender' className='add-only' value='She' /> She/Her/Hers
                        </td>
                        <td className='w-500'>
                            <input type='radio' id='rbPreferredPronoun' name='rbGender' className='add-only' value='PreferredPronoun' /> Preferred Pronoun: &nbsp;
                            <input type='text' id='txtPreferredPronoun' name='txtPreferredPronoun' className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbThey' name='rbGender' className='add-only' value='They' /> They/Them/Theirs
                        </td>
                        <td className='w-500'>
                            <input type='radio' id='rbPreferredClient' name='rbGender' className='add-only' value='Name client prefers to be called' /> Name client prefers to be called:
                            <input type='text' id='txtPreferredClient' name='txtPreferredClient' className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbAppropriate' name='rbGender' className='add-only' value='NotAgeAppropriate' /> Not age appropriate
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbGender_Other' name='rbGender' className='add-only' value='Other' /> Other: &nbsp;
                            <input type='text' id='txtGender_Other' name='txtGender_Other' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbNotAnswer' name='rbGender' className='add-only' value='PrefersNotToAnswerThisQuestion' /> Prefers not to answer this question
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Sexually active?</span>
                            <input type='radio' id='rbSexualActive_Yes' name='rbSexualActive' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbSexualActive_No' name='rbSexualActive' className='add-only' value='No' /> No &nbsp;
                            <input type='radio' id='rbSexualActive_Prefers' name='rbSexualActive' className='add-only' value='PrefersNotToAnswerThisQuestion' />
                            Prefers not to answer this question &nbsp;
                            <input type='radio' id='rbSexualActive_NotAge' name='rbSexualActive' className='add-only' value='NotAgeAppropriate' />
                            Not age appropriate
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Does the client have a reasonable (age appropriate) understanding of what 'safe-sex' means?</span>
                            <input type='radio' id='rbSafeSex_Yes' name='rbSafeSex' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbSafeSex_No' name='rbSafeSex' className='add-only' value='No' /> No &nbsp;
                            <input type='radio' id='rbSafeSex_Prefers' name='rbSafeSex' className='add-only' value='PrefersNotToAnswerThisQuestion' /> Prefers not to answer this question &nbsp;
                            <input type='radio' id='rbSafeSex_NotAge' name='rbSafeSex' className='add-only' value='NotAgeAppropriate' /> Not age appropriate
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>If yes, does the client report participating 'safe-sex' all of the time?</span>
                            <input type='radio' id='rbClientSafeSex_Yes' name='rbClientSafeSex' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbClientSafeSex_No' name='rbClientSafeSex' className='add-only' value='No' /> No &nbsp;
                            <input type='radio' id='rbClientSafeSex_Prefers' name='rbClientSafeSex' className='add-only' value='PrefersNotToAnswerThisQuestion' /> Prefers not to answer this question &nbsp;
                            <input type='radio' id='rbClientSafeSex_NotAge' name='rbClientSafeSex' className='add-only' value='NotAgeAppropriate' /> Not age appropriate
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>If yes, what methods?</span>
                            <input type='text' id='txtWhatMethods' name='txtWhatMethods' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbWhatMethods_Prefers' name='rbWhatMethods' className='add-only' value='PrefersNotToAnswerThisQuestion' /> Prefers not to answer this question &nbsp;
                            <input type='radio' id='rbWhatMethods_NotAge' name='rbWhatMethods' className='add-only' value='NotAgeAppropriate' /> Not age appropriate
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>If client does engage in unsafe sexual practices, does the client report ever being tested for Sexually Transmitted Diseases (STDs)?</span>
                            <input type='radio' id='rbUnsafeSexual_Yes' name='rbUnsafeSexual' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbUnsafeSexual_No' name='rbUnsafeSexual' className='add-only' value='No' /> No &nbsp;
                            <input type='radio' id='rbUnsafeSexual_Prefers' name='rbUnsafeSexual' className='add-only' value='PrefersNotToAnswerThisQuestion' /> Prefers not to answer this question &nbsp;
                            <input type='radio' id='rbUnsafeSexual_NotAge' name='rbUnsafeSexual' className='add-only' value='NotAgeAppropriate' /> Not age appropriate
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>If yes, when and how was client tested for STDs?</span>
                            <input type='text' id='txtClientTested' name='txtClientTested' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='radio' id='rbClientTested_NotAge' name='rbClientTested' className='add-only' value='NotAgeAppropriate' /> Not age appropriate
                        </td>
                        <td className='w-375'>
                            <input type='radio' id='rbClientTested_Prefers' name='rbClientTested' className='add-only' value='PrefersNotToAnswerThisQuestion' /> Prefers not to answer this question
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Does client report any history of contracting a STD?</span>
                            <input type='radio' id='rbReportClientHistory_Yes' name='rbReportClientHistory' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbReportClientHistory_No' name='rbReportClientHistory' className='add-only' value='No' /> No &nbsp;
                            <input type='radio' id='rbReportClientHistory_Prefers' name='rbReportClientHistory' className='add-only' value='PrefersNotToAnswerThisQuestion' /> Prefers not to answer this question &nbsp;
                            <input type='radio' id='rbReportClientHistory_NotAge' name='rbReportClientHistory' className='add-only' value='NotAgeAppropriate' /> Not age appropriate
                            <span className='small'>If yes, please make sure this fact is listed in the medical portion of this assessment</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Does the client have an interest in being tested for STDs? </span>
                            <input type='radio' id='rbBeingTested_Yes' name='rbBeingTested' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbBeingTested_No' name='rbBeingTested' className='add-only' value='No' /> No &nbsp;
                            <input type='radio' id='rbBeingTested_Prefers' name='rbBeingTested' className='add-only' value='PrefersNotToAnswerThisQuestion' /> Prefers not to answer this question &nbsp;
                            <input type='radio' id='rbBeingTested_NotAge' name='rbBeingTested' className='add-only' value='NotAgeAppropriate' /> Not age appropriate
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Notes</span>
                    <textarea id='txtNotes_SexualHistory' name='txtNotes_SexualHistory' className='add-only'></textarea>
                </p>
                <p className='w-750'><h2>Behavior/Symptom Checklist</h2></p>
                <span className='small'>*Place the frequency next to the behavior: High (H), Medium (M), Low (L),No applicable (N/A)</span>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Behavior</span>
                        </td>
                        <td className='w-80'>
                            <span className='eleHeader'>Severe</span>
                        </td>
                        <td className='w-80'>
                            <span className='eleHeader'>Moderate</span>
                        </td>
                        <td className='w-80'>
                            <span className='eleHeader'>Mild</span>
                        </td>
                        <td className='w-125'>
                            <span className='eleHeader'>Not applicable (N/A)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>Phobias or fears</td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbPhobiasOrFears_Severe' name='rbPhobiasOrFears' className='add-only' value='Severe' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbPhobiasOrFears_Moderate' name='rbPhobiasOrFears' className='add-only' value='Moderate' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbPhobiasOrFears_Mild' name='rbPhobiasOrFears' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-125'>
                            <center><input type='radio' id='rbPhobiasOrFears_NA' name='rbPhobiasOrFears' className='add-only' value='Na' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>Hyperactivity</td>

                        <td className='w-80'>
                            <center><input type='radio' id='rbHyperactivity_Severe' name='rbHyperactivity' className='add-only' value='Severe' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbHyperactivity_Moderate' name='rbHyperactivity' className='add-only' value='Moderate' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbHyperactivity_Mild' name='rbHyperactivity' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-125'>
                            <center><input type='radio' id='rbHyperactivity_NA' name='rbHyperactivity' className='add-only' value='Na' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>Impulsivity</td>

                        <td className='w-80'>
                            <center><input type='radio' id='rbImpulsivity_Severe' name='rbImpulsivity' className='add-only' value='Severe' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbImpulsivity_Moderate' name='rbImpulsivity' className='add-only' value='Moderate' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbImpulsivity_Mild' name='rbImpulsivity' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-125'>
                            <center><input type='radio' id='rbImpulsivity_NA' name='rbImpulsivity' className='add-only' value='Na' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>Restlessness</td>

                        <td className='w-80'>
                            <center><input type='radio' id='rbRestlessness_Severe' name='rbRestlessness' className='add-only' value='Severe' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbRestlessness_Moderate' name='rbRestlessness' className='add-only' value='Moderate' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbRestlessness_Mild' name='rbRestlessness' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-125'>
                            <center><input type='radio' id='rbRestlessness_NA' name='rbRestlessness' className='add-only' value='Na' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>Tearfulness</td>

                        <td className='w-80'>
                            <center><input type='radio' id='rbTearfulness_Severe' name='rbTearfulness' className='add-only' value='Severe' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbTearfulness_Moderate' name='rbTearfulness' className='add-only' value='Moderate' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbTearfulness_Mild' name='rbTearfulness' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-125'>
                            <center><input type='radio' id='rbTearfulness_NA' name='rbTearfulness' className='add-only' value='Na' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>Whining</td>

                        <td className='w-80'>
                            <center><input type='radio' id='rbWhining_Severe' name='rbWhining' className='add-only' value='Severe' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbWhining_Moderate' name='rbWhining' className='add-only' value='Moderate' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbWhining_Mild' name='rbWhining' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-125'>
                            <center><input type='radio' id='rbWhining_NA' name='rbWhining' className='add-only' value='Na' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>Manipulative</td>

                        <td className='w-80'>
                            <center><input type='radio' id='rbManipulative_Severe' name='rbManipulative' className='add-only' value='Severe' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbManipulative_Moderate' name='rbManipulative' className='add-only' value='Moderate' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbManipulative_Mild' name='rbManipulative' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-125'>
                            <center><input type='radio' id='rbManipulative_NA' name='rbManipulative' className='add-only' value='Na' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>Stubbornness</td>

                        <td className='w-80'>
                            <center><input type='radio' id='rbStubbornness_Severe' name='rbStubbornness' className='add-only' value='Severe' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbStubbornness_Moderate' name='rbStubbornness' className='add-only' value='Moderate' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbStubbornness_Mild' name='rbStubbornness' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-125'>
                            <center><input type='radio' id='rbStubbornness_NA' name='rbStubbornness' className='add-only' value='Na' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>Frequent temper tantrums</td>

                        <td className='w-80'>
                            <center><input type='radio' id='rbFrequent_Severe' name='rbFrequent' className='add-only' value='Severe' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbFrequent_Moderate' name='rbFrequent' className='add-only' value='Moderate' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbFrequent_Mild' name='rbFrequent' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-125'>
                            <center><input type='radio' id='rbFrequent_NA' name='rbFrequent' className='add-only' value='Na' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>Holding breath</td>

                        <td className='w-80'>
                            <center><input type='radio' id='rbHolding_Severe' name='rbHolding' className='add-only' value='Severe' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbHolding_Moderate' name='rbHolding' className='add-only' value='Moderate' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbHolding_Mild' name='rbHolding' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-125'>
                            <center><input type='radio' id='rbHolding_NA' name='rbHolding' className='add-only' value='Na' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>Harming self, others, animals</td>

                        <td className='w-80'>
                            <center><input type='radio' id='rbHarming_Severe' name='rbHarming' className='add-only' value='Severe' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbHarming_Moderate' name='rbHarming' className='add-only' value='Moderate' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbHarming_Mild' name='rbHarming' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-125'>
                            <center><input type='radio' id='rbHarming_NA' name='rbHarming' className='add-only' value='Na' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>Self-injurious behaviors (e.g., cutting; hair pulling)</td>

                        <td className='w-80'>
                            <center><input type='radio' id='rbSelfInjurious_Severe' name='rbSelfInjurious' className='add-only' value='Severe' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbSelfInjurious_Moderate' name='rbSelfInjurious' className='add-only' value='Moderate' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbSelfInjurious_Mild' name='rbSelfInjurious' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-125'>
                            <center><input type='radio' id='rbSelfInjurious_NA' name='rbSelfInjurious' className='add-only' value='Na' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>Sexually aggressive</td>

                        <td className='w-80'>
                            <center><input type='radio' id='rbSexuallyAggressive_Severe' name='rbSexuallyAggressive' className='add-only' value='Severe' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbSexuallyAggressive_Moderate' name='rbSexuallyAggressive' className='add-only' value='Moderate' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbSexuallyAggressive_Mild' name='rbSexuallyAggressive' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-125'>
                            <center><input type='radio' id='rbSexuallyAggressive_NA' name='rbSexuallyAggressive' className='add-only' value='Na' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>Sexually active</td>

                        <td className='w-80'>
                            <center><input type='radio' id='rbSexuallyActive_Severe' name='rbSexuallyActive' className='add-only' value='Severe' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbSexuallyActive_Moderate' name='rbSexuallyActive' className='add-only' value='Moderate' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbSexuallyActive_Mild' name='rbSexuallyActive' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-125'>
                            <center><input type='radio' id='rbSexuallyActive_NA' name='rbSexuallyActive' className='add-only' value='Na' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>Lying/stealing</td>

                        <td className='w-80'>
                            <center><input type='radio' id='rbLyingstealing_Severe' name='rbLyingstealing' className='add-only' value='Severe' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbLyingstealing_Moderate' name='rbLyingstealing' className='add-only' value='Moderate' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbLyingstealing_Mild' name='rbLyingstealing' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-125'>
                            <center><input type='radio' id='rbLyingstealing_NA' name='rbLyingstealing' className='add-only' value='Na' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>Destructive</td>

                        <td className='w-80'>
                            <center><input type='radio' id='rbDestructive_Severe' name='rbDestructive' className='add-only' value='Severe' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbDestructive_Moderate' name='rbDestructive' className='add-only' value='Moderate' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbDestructive_Mild' name='rbDestructive' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-125'>
                            <center><input type='radio' id='rbDestructive_NA' name='rbDestructive' className='add-only' value='Na' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>Rocking back and forth</td>

                        <td className='w-80'>
                            <center><input type='radio' id='rbRocking_Severe' name='rbRocking' className='add-only' value='Severe' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbRocking_Moderate' name='rbRocking' className='add-only' value='Moderate' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbRocking_Mild' name='rbRocking' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-125'>
                            <center><input type='radio' id='rbRocking_NA' name='rbRocking' className='add-only' value='Na' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>Hand flapping</td>

                        <td className='w-80'>
                            <center><input type='radio' id='rbHand_Severe' name='rbHand' className='add-only' value='Severe' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbHand_Moderate' name='rbHand' className='add-only' value='Moderate' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbHand_Mild' name='rbHand' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-125'>
                            <center><input type='radio' id='rbHand_NA' name='rbHand' className='add-only' value='Na' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>Difficulty with physical coordination</td>

                        <td className='w-80'>
                            <center><input type='radio' id='rbDifficult_Severe' name='rbDifficult' className='add-only' value='Severe' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbDifficult_Moderate' name='rbDifficult' className='add-only' value='Moderate' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbDifficult_Mild' name='rbDifficult' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-125'>
                            <center><input type='radio' id='rbDifficult_NA' name='rbDifficult' className='add-only' value='Na' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>Pica</td>

                        <td className='w-80'>
                            <center><input type='radio' id='rbPica_Severe' name='rbPica' className='add-only' value='Severe' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbPica_Moderate' name='rbPica' className='add-only' value='Moderate' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbPica_Mild' name='rbPica' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-125'>
                            <center><input type='radio' id='rbPica_NA' name='rbPica' className='add-only' value='Na' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>Inattentiveness</td>

                        <td className='w-80'>
                            <center><input type='radio' id='rbInattentiveness_Severe' name='rbInattentiveness' className='add-only' value='Severe' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbInattentiveness_Moderate' name='rbInattentiveness' className='add-only' value='Moderate' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbInattentiveness_Mild' name='rbInattentiveness' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-125'>
                            <center><input type='radio' id='rbInattentiveness_NA' name='rbInattentiveness' className='add-only' value='Na' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>Bed wetting</td>

                        <td className='w-80'>
                            <center><input type='radio' id='rbBed_Severe' name='rbBed' className='add-only' value='Severe' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbBed_Moderate' name='rbBed' className='add-only' value='Moderate' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbBed_Mild' name='rbBed' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-125'>
                            <center><input type='radio' id='rbBed_NA' name='rbBed' className='add-only' value='Na' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>Low self-esteem</td>

                        <td className='w-80'>
                            <center><input type='radio' id='rbLow_Severe' name='rbLow' className='add-only' value='Severe' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbLow_Moderate' name='rbLow' className='add-only' value='Moderate' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbLow_Mild' name='rbLow' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-125'>
                            <center><input type='radio' id='rbLow_NA' name='rbLow' className='add-only' value='Na' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>Preferring to be alone</td>

                        <td className='w-80'>
                            <center><input type='radio' id='rbAlone_Severe' name='rbAlone' className='add-only' value='Severe' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbAlone_Moderate' name='rbAlone' className='add-only' value='Moderate' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbAlone_Mild' name='rbAlone' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-125'>
                            <center><input type='radio' id='rbAlone_NA' name='rbAlone' className='add-only' value='Na' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>Antisocial personality traits</td>

                        <td className='w-80'>
                            <center><input type='radio' id='rbAntisocial_Severe' name='rbAntisocial' className='add-only' value='Severe' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbAntisocial_Moderate' name='rbAntisocial' className='add-only' value='Moderate' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbAntisocial_Mild' name='rbAntisocial' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-125'>
                            <center><input type='radio' id='rbAntisocial_NA' name='rbAntisocial' className='add-only' value='Na' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>Unstable self-image</td>

                        <td className='w-80'>
                            <center><input type='radio' id='rbUnstable_Severe' name='rbUnstable' className='add-only' value='Severe' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbUnstable_Moderate' name='rbUnstable' className='add-only' value='Moderate' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbUnstable_Mild' name='rbUnstable' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-125'>
                            <center><input type='radio' id='rbUnstable_NA' name='rbUnstable' className='add-only' value='Na' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>Dramatic</td>

                        <td className='w-80'>
                            <center><input type='radio' id='rbDramatic_Severe' name='rbDramatic' className='add-only' value='Severe' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbDramatic_Moderate' name='rbDramatic' className='add-only' value='Moderate' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbDramatic_Mild' name='rbDramatic' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-125'>
                            <center><input type='radio' id='rbDramatic_NA' name='rbDramatic' className='add-only' value='Na' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>Aggressiveness/angry outbursts</td>

                        <td className='w-80'>
                            <center><input type='radio' id='rbAggressiveness_Severe' name='rbAggressiveness' className='add-only' value='Severe' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbAggressiveness_Moderate' name='rbAggressiveness' className='add-only' value='Moderate' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbAggressiveness_Mild' name='rbAggressiveness' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-125'>
                            <center><input type='radio' id='rbAggressiveness_NA' name='rbAggressiveness' className='add-only' value='Na' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>Errors in judgment</td>

                        <td className='w-80'>
                            <center><input type='radio' id='rbErrors_Severe' name='rbErrors' className='add-only' value='Severe' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbErrors_Moderate' name='rbErrors' className='add-only' value='Moderate' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbErrors_Mild' name='rbErrors' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-125'>
                            <center><input type='radio' id='rbErrors_NA' name='rbErrors' className='add-only' value='Na' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>Elevated/expansive mood</td>

                        <td className='w-80'>
                            <center><input type='radio' id='rbElevated_Severe' name='rbElevated' className='add-only' value='Severe' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbElevated_Moderate' name='rbElevated' className='add-only' value='Moderate' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbElevated_Mild' name='rbElevated' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-125'>
                            <center><input type='radio' id='rbElevated_NA' name='rbElevated' className='add-only' value='Na' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>Disorientation</td>

                        <td className='w-80'>
                            <center><input type='radio' id='rbDisorientation_Severe' name='rbDisorientation' className='add-only' value='Severe' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbDisorientation_Moderate' name='rbDisorientation' className='add-only' value='Moderate' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbDisorientation_Mild' name='rbDisorientation' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-125'>
                            <center><input type='radio' id='rbDisorientation_NA' name='rbDisorientation' className='add-only' value='Na' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>Memory issues</td>

                        <td className='w-80'>
                            <center><input type='radio' id='rbMemory_Severe' name='rbMemory' className='add-only' value='Severe' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbMemory_Moderate' name='rbMemory' className='add-only' value='Moderate' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbMemory_Mild' name='rbMemory' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-125'>
                            <center><input type='radio' id='rbMemory_NA' name='rbMemory' className='add-only' value='Na' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>Feelings of hopelessness</td>

                        <td className='w-80'>
                            <center><input type='radio' id='rbFeelings_Severe' name='rbFeelings' className='add-only' value='Severe' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbFeelings_Moderate' name='rbFeelings' className='add-only' value='Moderate' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbFeelings_Mild' name='rbFeelings' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-125'>
                            <center><input type='radio' id='rbFeelings_NA' name='rbFeelings' className='add-only' value='Na' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>Ruminating</td>

                        <td className='w-80'>
                            <center><input type='radio' id='rbRuminating_Severe' name='rbRuminating' className='add-only' value='Severe' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbRuminating_Moderate' name='rbRuminating' className='add-only' value='Moderate' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbRuminating_Mild' name='rbRuminating' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-125'>
                            <center><input type='radio' id='rbRuminating_NA' name='rbRuminating' className='add-only' value='Na' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>Medical issues</td>

                        <td className='w-80'>
                            <center><input type='radio' id='rbMedicalIssue_Severe' name='rbMedicalIssue' className='add-only' value='Severe' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbMedicalIssue_Moderate' name='rbMedicalIssue' className='add-only' value='Moderate' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbMedicalIssue_Mild' name='rbMedicalIssue' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-125'>
                            <center><input type='radio' id='rbMedicalIssue_NA' name='rbMedicalIssue' className='add-only' value='Na' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>Pyromania</td>

                        <td className='w-80'>
                            <center><input type='radio' id='rbPyromania_Severe' name='rbPyromania' className='add-only' value='Severe' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbPyromania_Moderate' name='rbPyromania' className='add-only' value='Moderate' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbPyromania_Mild' name='rbPyromania' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-125'>
                            <center><input type='radio' id='rbPyromania_NA' name='rbPyromania' className='add-only' value='Na' /></center>
                        </td>
                    </tr>
                </table>
                <p className='w-750'><h2>Emotional Status/Mental Status Examination (MSE)</h2></p>
                <p className='w-750'><h3>Does client currently or does client regularly experience any of the following:</h3></p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Feelings of extreme sadness, hopelessness or depression?</span>
                            <input type='radio' id='rbSadness_Yes' name='rbSadness' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbSadness_No' name='rbSadness' className='add-only' value='No' /> No
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Extreme tension, worry, or anxiety?</span>
                            <input type='radio' id='rbTension_Yes' name='rbTension' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbTension_No' name='rbTension' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Feelings of extreme fear or panic?</span>
                            <input type='radio' id='rbFearPanic_Yes' name='rbFearPanic' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbFearPanic_No' name='rbFearPanic' className='add-only' value='No' /> No
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Feeling unable to sleep or eat?</span>
                            <input type='radio' id='rbSleepEat_Yes' name='rbSleepEat' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbSleepEat_No' name='rbSleepEat' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Regularly feeling unable to control your anger or thoughts?</span>
                            <input type='radio' id='rbRegulayFeeling_Yes' name='rbRegulayFeeling' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbRegulayFeeling_No' name='rbRegulayFeeling' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Regularly hearing voices, seeing things, smelling things, feelings things, or tasting things that other people did not see, hear, smell, feel, or taste?
                            </span>
                            <input type='radio' id='rbRegulayHearing_Yes' name='rbRegulayHearing' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbRegulayHearing_No' name='rbRegulayHearing' className='add-only' value='No' /> No
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>If client answers yes to any of the above</span>
                    <span className='small'>(Please explain):</span>
                    <textarea id='txtClientAnswer' name='txtClientAnswer' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Behavior</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbNormal' name='cbNormal' className='add-only' value='1' />
                            Normal
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cHyperactive' name='cHyperactive' className='add-only' value='1' />
                            Hyperactive
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbWithdrawn' name='cbWithdrawn' className='add-only' value='1' />
                            Withdrawn
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <input type='checkbox' id='cbResistant' name='cbResistant' className='add-only' value='1' />
                            Resistant/aggressive
                        </td>

                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbBehavior_Other' name='cbBehavior_Other' className='add-only' value='1' />
                            Other (Specify): &nbsp;
                            <input type='text' id='txtBehavior_Other' name='txtBehavior_Other' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Speech</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbSpeech_Normal' name='cbSpeech_Normal' className='add-only' value='1' />
                            Normal
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbRapid' name='cbRapid' className='add-only' value='1' />
                            Rapid
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbSlow' name='cbSlow' className='add-only' value='1' />
                            Slow
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbSlurred' name='cbSlurred' className='add-only' value='1' />
                            Slurred or incoherent
                        </td>

                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbSpeech_Other' name='cbSpeech_Other' className='add-only' value='1' />
                            Other (Specify): &nbsp;
                            <input type='text' id='txtSpeech_Other' name='txtSpeech_Other' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'><h3>Did client know:</h3></p>
                <table>
                    <tr>
                        <td className='w-187'>
                            <span className='eleHeader'>His/her name?</span>
                            <input type='Radio' id='rbHis_Yes' name='rbHis' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='Radio' id='rbHis_No' name='rbHis' className='add-only' value='No' /> No
                        </td>
                        <td className='w-187'>
                            <span className='eleHeader'>Where he/she is?</span>
                            <input type='Radio' id='rbShe_Yes' name='rbShe' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='Radio' id='rbShe_No' name='rbShe' className='add-only' value='No' /> No
                        </td>
                        <td className='w-187'>
                            <span className='eleHeader'>Today's Date?</span>
                            <input type='Radio' id='rbDate_Yes' name='rbDate' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='Radio' id='rbDate_No' name='rbDate' className='add-only' value='No' /> No
                        </td>
                        <td className='w-187'>
                            <span className='eleHeader'>The time of day?</span>
                            <input type='Radio' id='rbTimeDay_Yes' name='rbTimeDay' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='Radio' id='rbTimeDay_No' name='rbTimeDay' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbAdditionalObservations' name='cbAdditionalObservations' className='add-only' value='1' />
                            Additional observations and/or reports suggest possible difficulties with:

                            <table>
                                <tr>
                                    <td className='w-20'></td>
                                    <td className='w-250'>
                                        <input type='checkbox' id='cbPersonalhygiene' name='cbPersonalhygiene' className='add-only' value='1' />
                                        Personal hygiene
                                    </td>
                                    <td className='w-250'>
                                        <input type='checkbox' id='cbMannerofdress' name='cbMannerofdress' className='add-only' value='1' />
                                        Manner of dress
                                    </td>
                                    <td className='w-230'>
                                        <input type='checkbox' id='cbMoodAffect' name='cbMoodAffect' className='add-only' value='1' />
                                        Mood/affect
                                    </td>
                                </tr>
                                <tr>
                                    <td className='w-20'></td>
                                    <td className='w-250'>
                                        <input type='checkbox' id='cbMemoryActivity' name='cbMemoryActivity' className='add-only' value='1' />
                                        Memory activity
                                    </td>
                                    <td className='w-250'>
                                        <input type='checkbox' id='cbSpeech' name='cbSpeech' className='add-only' value='1' />
                                        Speech
                                    </td>
                                    <td className='w-230'>
                                        <input type='checkbox' id='cbThoughtflow' name='cbThoughtflow' className='add-only' value='1' />
                                        Thought flow/content
                                    </td>
                                </tr>
                                <tr>
                                    <td className='w-20'></td>
                                    <td className='w-250'>
                                        <input type='checkbox' id='cbMemoryOrientation' name='cbMemoryOrientation' className='add-only' value='1' />
                                        Memory/orientation
                                    </td>
                                    <td className='w-250'>
                                        <input type='checkbox' id='cbHallucinationsDelusions' name='cbHallucinationsDelusions' className='add-only' value='1' />
                                        Hallucinations/delusions
                                    </td>
                                    <td className='w-230'>
                                        <input type='checkbox' id='cbInsightJudgment' name='cbInsightJudgment' className='add-only' value='1' />
                                        Insight/judgment
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                </table>
                <p className='w-750'><h2>Client Suicide Assessment</h2></p>

                <table>
                    <tr>
                        <td className='w-550'><span className='eleHeader'>Please compete the following</span></td>
                        <td className='w-100'>
                            <span className='eleHeader'>Yes</span>
                        </td>
                        <td className='w-100'>
                            <span className='eleHeader'>No</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-550'>Is there a history of suicide in the client's family of origin?
                        </td>
                        <td className='w-100'>
                            <input type='radio' id='rb_HistorySuicide_Yes' name='rb_HistorySuicide' className='add-only' value='Yes' />
                        </td>
                        <td className='w-100'>
                            <input type='radio' id='rbrb_HistorySuicide_No' name='rb_HistorySuicide' className='add-only' value='No' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-550'>Does client report current substance abuse?
                        </td>
                        <td className='w-100'>
                            <input type='radio' id='rbSubstanceUse_Yes' name='rbSubstanceUse' className='add-only' value='Yes' />
                        </td>
                        <td className='w-100'>
                            <input type='radio' id='rbSubstanceUse_No' name='rbSubstanceUse' className='add-only' value='No' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-550'>Does client report poor social/natural supports?
                        </td>
                        <td className='w-100'>
                            <input type='radio' id='rbNaturalSports_Yes' name='rbNaturalSports' className='add-only' value='Yes' />
                        </td>
                        <td className='w-100'>
                            <input type='radio' id='rbNaturalSports_No' name='rbNaturalSports' className='add-only' value='No' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-550'>Does client exhibit or report depressive symptoms?
                        </td>
                        <td className='w-100'>
                            <input type='radio' id='rbDepressive_Yes' name='rbDepressive_Yes' className='add-only' value='Yes' />
                        </td>
                        <td className='w-100'>
                            <input type='radio' id='rbDepressive_No' name='rbDepressive_Yes' className='add-only' value='No' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-550'>Does client report feelings of hopelessness?
                        </td>
                        <td className='w-100'>
                            <input type='radio' id='rbHopelessness_Yes' name='rbHopelessness' className='add-only' value='Yes' />
                        </td>
                        <td className='w-100'>
                            <input type='radio' id='rbHopelessness_No' name='rbHopelessness' className='add-only' value='No' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-550'>Does client exhibit or report psychotic symptoms?
                        </td>
                        <td className='w-100'>
                            <input type='radio' id='rbPsychoticSymtoms_Yes' name='rbPsychoticSymtoms' className='add-only' value='Yes' />
                        </td>
                        <td className='w-100'>
                            <input type='radio' id='rbPsychoticSymtoms_No' name='rbPsychoticSymtoms' className='add-only' value='No' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-550'>Does client report anhedonia?
                        </td>
                        <td className='w-100'>
                            <input type='radio' id='rbAnhedonia_Yes' name='rbAnhedonia' className='add-only' value='Yes' />
                        </td>
                        <td className='w-100'>
                            <input type='radio' id='rbAnhedonia_No' name='rbAnhedonia' className='add-only' value='No' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-550'>Does client report or exhibit anger/impulsivity?
                        </td>
                        <td className='w-100'>
                            <input type='radio' id='rbExhibit_Yes' name='rbExhibit' className='add-only' value='Yes' />
                        </td>
                        <td className='w-100'>
                            <input type='radio' id='rbExhibit_No' name='rbExhibit' className='add-only' value='No' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-550'>Does client report current suicidal ideation?
                        </td>
                        <td className='w-100'>
                            <input type='radio' id='rbSuicidalIdeation_Yes' name='rbSuicidalIdeation' className='add-only' value='Yes' />
                        </td>
                        <td className='w-100'>
                            <input type='radio' id='rbSuicidalIdeation_No' name='rbSuicidalIdeation' className='add-only' value='No' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-550'>Does client report currently having a plan to commit suicide?
                        </td>
                        <td className='w-100'>
                            <input type='radio' id='rbCommitSuicide_Yes' name='rbCommitSuicide' className='add-only' value='Yes' />
                        </td>
                        <td className='w-100'>
                            <input type='radio' id='rbCommitSuicide_No' name='rbCommitSuicide' className='add-only' value='No' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-550'>Does client report having access to lethal items or means?
                        </td>
                        <td className='w-100'>
                            <input type='radio' id='rbLethalItems_Yes' name='rbLethalItems' className='add-only' value='Yes' />
                        </td>
                        <td className='w-100'>
                            <input type='radio' id='rbLethalItems_No' name='rbLethalItems' className='add-only' value='No' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-550'>Does client have a history of suicide attempt(s)?
                        </td>
                        <td className='w-100'>
                            <input type='radio' id='rbSuicideHistory_Yes' name='rbSuicideHistory' className='add-only' value='Yes' />
                        </td>
                        <td className='w-100'>
                            <input type='radio' id='rbSuicideHistory_No' name='rbSuicideHistory' className='add-only' value='No' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-550'>Client reports feeling like there is no solution for his/her current issues?
                        </td>
                        <td className='w-100'>
                            <input type='radio' id='rbCurrentIssues_Yes' name='rbCurrentIssues' className='add-only' value='Yes' />
                        </td>
                        <td className='w-100'>
                            <input type='radio' id='rbCurrentIssues_No' name='rbCurrentIssues' className='add-only' value='No' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-550'>Does client report current command hallucinations with a suicidal or homicidal theme?
                        </td>
                        <td className='w-100'>
                            <input type='radio' id='rbHomicidal_Yes' name='rbHomicidal' className='add-only' value='Yes' />
                        </td>
                        <td className='w-100'>
                            <input type='radio' id='rbHomicidal_No' name='rbHomicidal' className='add-only' value='No' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-550'>Does client report using substances within the past 24 hours?
                        </td>
                        <td className='w-100'>
                            <input type='radio' id='rbSubstance24Hours_Yes' name='rbSubstance24Hours' className='add-only' value='Yes' />
                        </td>
                        <td className='w-100'>
                            <input type='radio' id='rbSubstance24Hours_No' name='rbSubstance24Hours' className='add-only' value='No' />
                        </td>
                    </tr>
                </table>
                <span className='eleHeader'>Assessment Scoring</span>
                <p className='w-750'>
                    A 'Yes' response to 0 - 2 of the above questions =<b>Low suicide risk</b>
                </p>
                <p className='w-750'>
                    A 'Yes' response to 3 - 5 of the above questions =<b>Moderate suicide risk</b>
                </p>
                <p className='w-750'>
                    A 'Yes' response to 6 - 15 of the above questions =<b>High suicide risk</b>
                </p>
                <p className='w-750'>
                    <b>If client responds affirmatively to any of the above questions, please notify the parent/guardian
                        of the client's suicide risk level, complete a  Safety Plan,
                        and notify the Clinical Director on the same date as the assessment is completed. </b>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbNotifiedParent' name='cbNotifiedParent' className='add-only' value='1' />
                            Notified parent/guardian
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <input type='checkbox' id='cbBehavioralHealth' name='cbBehavioralHealth' className='add-only' value='1' />
                            Completed  Safety Plan
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <input type='checkbox' id='cbAssessment' name='cbAssessment' className='add-only' value='1' />
                            Notified Clinical Director on the same date as the assessment is completed
                        </td>
                    </tr>
                </table>
                <p className='w-750'><h2>Substance Use History Assessment</h2></p>
                <table>
                    <tr>
                        <td className='w-390'>
                            <span className='eleHeader'>A. Have you ever used any of the following:</span>
                        </td>
                        <td className='w-60'>
                            <span className='eleHeader'>Never</span>
                        </td>
                        <td className='w-80'>
                            <span className='eleHeader'>Once Or Twice</span>
                        </td>
                        <td className='w-60'>
                            <span className='eleHeader'>Monthly</span>
                        </td>
                        <td className='w-60'>
                            <span className='eleHeader'>Weekly</span>
                        </td>
                        <td className='w-100'>
                            <span className='eleHeader'>Daily or almost daily</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>1. Tobacco products (cigarettes, chewing tobacco, cigars, etc.)</td>

                        <td className='w-60'>
                            <center><input type='radio' id='rbTabacco_1' name='rbTabacco' className='add-only' value='Never' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbTabacco_2' name='rbTabacco' className='add-only' value='OnceOrTwice' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbTabacco_3' name='rbTabacco' className='add-only' value='Monthly' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbTabacco_4' name='rbTabacco' className='add-only' value='Weekly' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbTabacco_5' name='rbTabacco' className='add-only' value='DaliyOrAlmostDaily' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>2. Alcoholic beverages (beer, wine, spirits, etc.)</td>

                        <td className='w-60'>
                            <center><input type='radio' id='rbAlcoholic_1' name='rbAlcoholic' className='add-only' value='Never' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbAlcoholic_2' name='rbAlcoholic' className='add-only' value='OnceOrTwice' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbAlcoholic_3' name='rbAlcoholic' className='add-only' value='Monthly' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbAlcoholic_4' name='rbAlcoholic' className='add-only' value='Weekly' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbAlcoholic_5' name='rbAlcoholic' className='add-only' value='DaliyOrAlmostDaily' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>3. Cannabis (marijuana , pot, grass, hash, etc.)</td>

                        <td className='w-60'>
                            <center><input type='radio' id='rbCannabis_1' name='rbCannabis' className='add-only' value='Never' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbCannabis_2' name='rbCannabis' className='add-only' value='OnceOrTwice' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbCannabis_3' name='rbCannabis' className='add-only' value='Monthly' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbCannabis_4' name='rbCannabis' className='add-only' value='Weekly' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbCannabis_5' name='rbCannabis' className='add-only' value='DaliyOrAlmostDaily' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>4. Cocaine  (coke, crack, etc.)</td>

                        <td className='w-60'>
                            <center><input type='radio' id='rbCocaine_1' name='rbCocaine' className='add-only' value='Never' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbCocaine_2' name='rbCocaine' className='add-only' value='OnceOrTwice' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbCocaine_3' name='rbCocaine' className='add-only' value='Monthly' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbCocaine_4' name='rbCocaine' className='add-only' value='Weekly' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbCocaine_5' name='rbCocaine' className='add-only' value='DaliyOrAlmostDaily' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>5. Amphetamine type stimulants (speed, diet pills, ecstasy, etc.)</td>

                        <td className='w-60'>
                            <center><input type='radio' id='rbAmphetamine_1' name='rbAmphetamine' className='add-only' value='Never' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbAmphetamine_2' name='rbAmphetamine' className='add-only' value='OnceOrTwice' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbAmphetamine_3' name='rbAmphetamine' className='add-only' value='Monthly' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbAmphetamine_4' name='rbAmphetamine' className='add-only' value='Weekly' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbAmphetamine_5' name='rbAmphetamine' className='add-only' value='DaliyOrAlmostDaily' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>6. Inhalants (nitrous, glue, petrol, paint thinner, etc.)</td>

                        <td className='w-60'>
                            <center><input type='radio' id='rbInhalants_1' name='rbInhalants' className='add-only' value='Never' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbInhalants_2' name='rbInhalants' className='add-only' value='OnceOrTwice' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbInhalants_3' name='rbInhalants' className='add-only' value='Monthly' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbInhalants_4' name='rbInhalants' className='add-only' value='Weekly' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbInhalants_5' name='rbInhalants' className='add-only' value='DaliyOrAlmostDaily' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>7. Sedatives or sleeping pills (Valium, Serepax, Rohypnol, etc.)</td>

                        <td className='w-60'>
                            <center><input type='radio' id='rbSedatives_1' name='rbSedatives' className='add-only' value='Never' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbSedatives_2' name='rbSedatives' className='add-only' value='OnceOrTwice' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbSedatives_3' name='rbSedatives' className='add-only' value='Monthly' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbSedatives_4' name='rbSedatives' className='add-only' value='Weekly' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbSedatives_5' name='rbSedatives' className='add-only' value='DaliyOrAlmostDaily' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>8. Hallucinogens (LSD, acid, mushrooms, PCP, Special K, etc.)</td>

                        <td className='w-60'>
                            <center><input type='radio' id='rbHallucinogens_1' name='rbHallucinogens' className='add-only' value='Never' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbHallucinogens_2' name='rbHallucinogens' className='add-only' value='OnceOrTwice' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbHallucinogens_3' name='rbHallucinogens' className='add-only' value='Monthly' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbHallucinogens_4' name='rbHallucinogens' className='add-only' value='Weekly' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHallucinogens_5' name='rbHallucinogens' className='add-only' value='DaliyOrAlmostDaily' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>9.	Opioids (heroin, morphine, methadone, codeine, etc.)</td>

                        <td className='w-60'>
                            <center><input type='radio' id='rbOpioids_1' name='rbOpioids' className='add-only' value='Never' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbOpioids_2' name='rbOpioids' className='add-only' value='OnceOrTwice' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbOpioids_3' name='rbOpioids' className='add-only' value='Monthly' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbOpioids_4' name='rbOpioids' className='add-only' value='Weekly' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbOpioids_5' name='rbOpioids' className='add-only' value='DaliyOrAlmostDaily' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>10.	Other - Specify:
                            <input type='text' id='txtOtherSpecify' name='txtOtherSpecify' className='add-only' />
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbOtherSpecify_1' name='rbOtherSpecify' className='add-only' value='Never' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbOtherSpecify_2' name='rbOtherSpecify' className='add-only' value='OnceOrTwice' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbOtherSpecify_3' name='rbOtherSpecify' className='add-only' value='Monthly' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbOtherSpecify_4' name='rbOtherSpecify' className='add-only' value='Weekly' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbOtherSpecify_5' name='rbOtherSpecify' className='add-only' value='DaliyOrAlmostDaily' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>
                            <span className='eleHeader'>B. During the past three months, how often have you had a b desire or urge to use the following:</span>
                        </td>
                        <td className='w-60'>
                            <span className='eleHeader'>Never</span>
                        </td>
                        <td className='w-80'>
                            <span className='eleHeader'>Once Or Twice</span>
                        </td>
                        <td className='w-60'>
                            <span className='eleHeader'>Monthly</span>
                        </td>
                        <td className='w-60'>
                            <span className='eleHeader'>Weekly</span>
                        </td>
                        <td className='w-100'>
                            <span className='eleHeader'>Daily or almost daily</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>1. Tobacco products (cigarettes, chewing tobacco, cigars, etc.)</td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbTabacco_B_1' name='rbTabacco_B' className='add-only' value='Never' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbTabacco_B_2' name='rbTabacco_B' className='add-only' value='OnceOrTwice' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbTabacco_B_3' name='rbTabacco_B' className='add-only' value='Monthly' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbTabacco_B_4' name='rbTabacco_B' className='add-only' value='Weekly' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbTabacco_B_5' name='rbTabacco_B' className='add-only' value='DaliyOrAlmostDaily' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>2. Alcoholic beverages (beer, wine, spirits, etc.)</td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbAlcoholic_B_1' name='rbAlcoholic_B' className='add-only' value='Never' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbAlcoholic_B_2' name='rbAlcoholic_B' className='add-only' value='OnceOrTwice' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbAlcoholic_B_3' name='rbAlcoholic_B' className='add-only' value='Monthly' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbAlcoholic_B_4' name='rbAlcoholic_B' className='add-only' value='Weekly' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbAlcoholic_B_5' name='rbAlcoholic_B' className='add-only' value='DaliyOrAlmostDaily' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>3. Cannabis (marijuana , pot, grass, hash, etc.)</td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbCannabis_B_1' name='rbCannabis_B' className='add-only' value='Never' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbCannabis_B_2' name='rbCannabis_B' className='add-only' value='OnceOrTwice' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbCannabis_B_3' name='rbCannabis_B' className='add-only' value='Monthly' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbCannabis_B_4' name='rbCannabis_B' className='add-only' value='Weekly' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbCannabis_B_5' name='rbCannabis_B' className='add-only' value='DaliyOrAlmostDaily' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>4. Cocaine  (coke, crack, etc.)</td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbCocaine_B_1' name='rbCocaine_B' className='add-only' value='Never' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbCocaine_B_2' name='rbCocaine_B' className='add-only' value='OnceOrTwice' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbCocaine_B_3' name='rbCocaine_B' className='add-only' value='Monthly' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbCocaine_B_4' name='rbCocaine_B' className='add-only' value='Weekly' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbCocaine_B_5' name='rbCocaine_B' className='add-only' value='DaliyOrAlmostDaily' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>5. Amphetamine type stimulants (speed, diet pills, ecstasy, etc.)</td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbAmphetamine_B_1' name='rbAmphetamine_B' className='add-only' value='Never' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbAmphetamine_B_2' name='rbAmphetamine_B' className='add-only' value='OnceOrTwice' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbAmphetamine_B_3' name='rbAmphetamine_B' className='add-only' value='Monthly' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbAmphetamine_B_4' name='rbAmphetamine_B' className='add-only' value='Weekly' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbAmphetamine_B_5' name='rbAmphetamine_B' className='add-only' value='DaliyOrAlmostDaily' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>6. Inhalants (nitrous, glue, petrol, paint thinner, etc.)
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbInhalants_B_1' name='rbInhalants_B' className='add-only' value='Never' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbInhalants_B_2' name='rbInhalants_B' className='add-only' value='OnceOrTwice' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbInhalants_B_3' name='rbInhalants_B' className='add-only' value='Monthly' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbInhalants_B_4' name='rbInhalants_B' className='add-only' value='Weekly' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbInhalants_B_5' name='rbInhalants_B' className='add-only' value='DaliyOrAlmostDaily' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>7. Sedatives or sleeping pills (Valium, Serepax, Rohypnol, etc.)
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbSedatives_B_1' name='rbSedatives_B' className='add-only' value='Never' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbSedatives_B_2' name='rbSedatives_B' className='add-only' value='OnceOrTwice' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbSedatives_B_3' name='rbSedatives_B' className='add-only' value='Monthly' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbSedatives_B_4' name='rbSedatives_B' className='add-only' value='Weekly' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbSedatives_B_5' name='rbSedatives_B' className='add-only' value='DaliyOrAlmostDaily' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>8. Hallucinogens (LSD, acid, mushrooms, PCP, Special K, etc.)</td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbHallucinogens_B_1' name='rbHallucinogens_B' className='add-only' value='Never' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbHallucinogens_B_2' name='rbHallucinogens_B' className='add-only' value='OnceOrTwice' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbHallucinogens_B_3' name='rbHallucinogens_B' className='add-only' value='Monthly' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbHallucinogens_B_4' name='rbHallucinogens_B' className='add-only' value='Weekly' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHallucinogens_B_5' name='rbHallucinogens_B' className='add-only' value='DaliyOrAlmostDaily' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>9.	Opioids (heroin, morphine, methadone, codeine, etc.)</td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbOpioids_B_1' name='rbOpioids_B' className='add-only' value='Never' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbOpioids_B_2' name='rbOpioids_B' className='add-only' value='OnceOrTwice' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbOpioids_B_3' name='rbOpioids_B' className='add-only' value='Monthly' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbOpioids_B_4' name='rbOpioids_B' className='add-only' value='Weekly' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbOpioids_B_5' name='rbOpioids_B' className='add-only' value='DaliyOrAlmostDaily' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>10.	Other - Specify:
                            <input type='text' id='txtOtherSpecify_B' name='txtOtherSpecify_B' className='add-only' />
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbOtherSpecify_B_1' name='rbOtherSpecify_B' className='add-only' value='Never' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbOtherSpecify_B_2' name='rbOtherSpecify' className='add-only' value='OnceOrTwice' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbOtherSpecify_B_3' name='rbOtherSpecify' className='add-only' value='Monthly' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbOtherSpecify_B_4' name='rbOtherSpecify' className='add-only' value='Weekly' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbOtherSpecify_B_5' name='rbOtherSpecify' className='add-only' value='DaliyOrAlmostDaily' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>
                            <span className='eleHeader'>C. During the past three months, how often has your use of the following led to health, relationship, social, legal or financial problems?</span>
                        </td>
                        <td className='w-60'>
                            <span className='eleHeader'>Never</span>
                        </td>
                        <td className='w-80'>
                            <span className='eleHeader'>Once Or Twice</span>
                        </td>
                        <td className='w-60'>
                            <span className='eleHeader'>Monthly</span>
                        </td>
                        <td className='w-60'>
                            <span className='eleHeader'>Weekly</span>
                        </td>
                        <td className='w-100'>
                            <span className='eleHeader'>Daily or almost daily</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>1. Tobacco products (cigarettes, chewing tobacco, cigars, etc.)</td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbTabacco_C_1' name='rbTabacco_C' className='add-only' value='Never' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbTabacco_C_2' name='rbTabacco_C' className='add-only' value='OnceOrTwice' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbTabacco_C_3' name='rbTabacco_C' className='add-only' value='Monthly' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbTabacco_C_4' name='rbTabacco_C' className='add-only' value='Weekly' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbTabacco_C_5' name='rbTabacco_C' className='add-only' value='DaliyOrAlmostDaily' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>2. Alcoholic beverages (beer, wine, spirits, etc.)</td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbAlcoholic_C_1' name='rbAlcoholic_C' className='add-only' value='Never' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbAlcoholic_C_2' name='rbAlcoholic_C' className='add-only' value='OnceOrTwice' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbAlcoholic_C_3' name='rbAlcoholic_C' className='add-only' value='Monthly' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbAlcoholic_C_4' name='rbAlcoholic_C' className='add-only' value='Weekly' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbAlcoholic_C_5' name='rbAlcoholic_C' className='add-only' value='DaliyOrAlmostDaily' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>3. Cannabis (marijuana , pot, grass, hash, etc.)</td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbCannabis_C_1' name='rbCannabis_C' className='add-only' value='Never' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbCannabis_C_2' name='rbCannabis_C' className='add-only' value='OnceOrTwice' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbCannabis_C_3' name='rbCannabis_C' className='add-only' value='Monthly' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbCannabis_C_4' name='rbCannabis_C' className='add-only' value='Weekly' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbCannabis_C_5' name='rbCannabis_C' className='add-only' value='DaliyOrAlmostDaily' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>4. Cocaine  (coke, crack, etc.)</td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbCocaine_C_1' name='rbCocaine_C' className='add-only' value='Never' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbCocaine_C_2' name='rbCocaine_C' className='add-only' value='OnceOrTwice' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbCocaine_C_3' name='rbCocaine_C' className='add-only' value='Monthly' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbCocaine_C_4' name='rbCocaine_C' className='add-only' value='Weekly' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbCocaine_C_5' name='rbCocaine_C' className='add-only' value='DaliyOrAlmostDaily' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>5. Amphetamine type stimulants (speed, diet pills, ecstasy, etc.)</td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbAmphetamine_C_1' name='rbAmphetamine_C' className='add-only' value='Never' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbAmphetamine_C_2' name='rbAmphetamine_C' className='add-only' value='OnceOrTwice' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbAmphetamine_C_3' name='rbAmphetamine_C' className='add-only' value='Monthly' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbAmphetamine_C_4' name='rbAmphetamine_C' className='add-only' value='Weekly' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbAmphetamine_C_5' name='rbAmphetamine_C' className='add-only' value='DaliyOrAlmostDaily' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>6. Inhalants (nitrous, glue, petrol, paint thinner, etc.)
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbInhalants_C_1' name='rbInhalants_C' className='add-only' value='Never' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbInhalants_C_2' name='rbInhalants_C' className='add-only' value='OnceOrTwice' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbInhalants_C_3' name='rbInhalants_C' className='add-only' value='Monthly' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbInhalants_C_4' name='rbInhalants_C' className='add-only' value='Weekly' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbInhalants_C_5' name='rbInhalants_C' className='add-only' value='DaliyOrAlmostDaily' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>7. Sedatives or sleeping pills (Valium, Serepax, Rohypnol, etc.)
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbSedatives_C_1' name='rbSedatives_C' className='add-only' value='Never' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbSedatives_C_2' name='rbSedatives_C' className='add-only' value='OnceOrTwice' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbSedatives_C_3' name='rbSedatives_C' className='add-only' value='Monthly' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbSedatives_C_4' name='rbSedatives_C' className='add-only' value='Weekly' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbSedatives_C_5' name='rbSedatives_C' className='add-only' value='DaliyOrAlmostDaily' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>8. Hallucinogens (LSD, acid, mushrooms, PCP, Special K, etc.)</td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbHallucinogens_C_1' name='rbHallucinogens_C' className='add-only' value='Never' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbHallucinogens_C_2' name='rbHallucinogens_C' className='add-only' value='OnceOrTwice' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbHallucinogens_C_3' name='rbHallucinogens_C' className='add-only' value='Monthly' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbHallucinogens_C_4' name='rbHallucinogens_C' className='add-only' value='Weekly' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHallucinogens_C_5' name='rbHallucinogens_C' className='add-only' value='DaliyOrAlmostDaily' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>9.	Opioids (heroin, morphine, methadone, codeine, etc.)</td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbOpioids_C_1' name='rbOpioids_C' className='add-only' value='Never' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbOpioids_C_2' name='rbOpioids_C' className='add-only' value='OnceOrTwice' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbOpioids_C_3' name='rbOpioids_C' className='add-only' value='Monthly' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbOpioids_C_4' name='rbOpioids_C' className='add-only' value='Weekly' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbOpioids_C_5' name='rbOpioids_C' className='add-only' value='DaliyOrAlmostDaily' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>10.	Other - Specify:
                            <input type='text' id='txtOtherSpecify_C' name='txtOtherSpecify_C' className='add-only' />
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbOtherSpecify_C_1' name='rbOtherSpecify_C' className='add-only' value='Never' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbOtherSpecify_C_2' name='rbOtherSpecify_C' className='add-only' value='OnceOrTwice' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbOtherSpecify_C_3' name='rbOtherSpecify_C' className='add-only' value='Monthly' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbOtherSpecify_C_4' name='rbOtherSpecify_C' className='add-only' value='Weekly' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbOtherSpecify_C_5' name='rbOtherSpecify_C' className='add-only' value='DaliyOrAlmostDaily' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>
                            <span className='eleHeader'>D. During the past three months, how often have you failed to do what was normally expected of you because of your use of the following:</span>
                        </td>
                        <td className='w-60'>
                            <span className='eleHeader'>Never</span>
                        </td>
                        <td className='w-80'>
                            <span className='eleHeader'>Once Or Twice</span>
                        </td>
                        <td className='w-60'>
                            <span className='eleHeader'>Monthly</span>
                        </td>
                        <td className='w-60'>
                            <span className='eleHeader'>Weekly</span>
                        </td>
                        <td className='w-100'>
                            <span className='eleHeader'>Daily or almost daily</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>1. Tobacco products (cigarettes, chewing tobacco, cigars, etc.)</td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbTabacco_D_1' name='rbTabacco_D' className='add-only' value='Never' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbTabacco_D_2' name='rbTabacco_D' className='add-only' value='OnceOrTwice' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbTabacco_D_3' name='rbTabacco_D' className='add-only' value='Monthly' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbTabacco_D_4' name='rbTabacco_D' className='add-only' value='Weekly' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbTabacco_D_5' name='rbTabacco_D' className='add-only' value='DaliyOrAlmostDaily' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>2. Alcoholic beverages (beer, wine, spirits, etc.)</td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbAlcoholic_D_1' name='rbAlcoholic_D' className='add-only' value='Never' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbAlcoholic_D_2' name='rbAlcoholic_D' className='add-only' value='OnceOrTwice' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbAlcoholic_D_3' name='rbAlcoholic_D' className='add-only' value='Monthly' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbAlcoholic_D_4' name='rbAlcoholic_D' className='add-only' value='Weekly' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbAlcoholic_D_5' name='rbAlcoholic_D' className='add-only' value='DaliyOrAlmostDaily' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>3. Cannabis (marijuana , pot, grass, hash, etc.)</td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbCannabis_D_1' name='rbCannabis_D' className='add-only' value='Never' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbCannabis_D_2' name='rbCannabis_D' className='add-only' value='OnceOrTwice' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbCannabis_D_3' name='rbCannabis_D' className='add-only' value='Monthly' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbCannabis_D_4' name='rbCannabis_D' className='add-only' value='Weekly' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbCannabis_D_5' name='rbCannabis_D' className='add-only' value='DaliyOrAlmostDaily' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>4. Cocaine  (coke, crack, etc.)</td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbCocaine_D_1' name='rbCocaine_D' className='add-only' value='Never' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbCocaine_D_2' name='rbCocaine_D' className='add-only' value='OnceOrTwice' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbCocaine_D_3' name='rbCocaine_D' className='add-only' value='Monthly' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbCocaine_D_4' name='rbCocaine_D' className='add-only' value='Weekly' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbCocaine_D_5' name='rbCocaine_D' className='add-only' value='DaliyOrAlmostDaily' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>5. Amphetamine type stimulants (speed, diet pills, ecstasy, etc.)</td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbAmphetamine_D_1' name='rbAmphetamine_D' className='add-only' value='Never' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbAmphetamine_D_2' name='rbAmphetamine_D' className='add-only' value='OnceOrTwice' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbAmphetamine_D_3' name='rbAmphetamine_D' className='add-only' value='Monthly' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbAmphetamine_D_4' name='rbAmphetamine_D' className='add-only' value='Weekly' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbAmphetamine_D_5' name='rbAmphetamine_D' className='add-only' value='DaliyOrAlmostDaily' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>6. Inhalants (nitrous, glue, petrol, paint thinner, etc.)
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbInhalants_D_1' name='rbInhalants_D' className='add-only' value='Never' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbInhalants_D_2' name='rbInhalants_D' className='add-only' value='OnceOrTwice' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbInhalants_D_3' name='rbInhalants_D' className='add-only' value='Monthly' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbInhalants_D_4' name='rbInhalants_D' className='add-only' value='Weekly' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbInhalants_D_5' name='rbInhalants_D' className='add-only' value='DaliyOrAlmostDaily' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>
                            <span className='eleHeader'>E. Has a friend, family member, or anyone else ever expressed concern about your use of the following:</span>
                        </td>
                        <td className='w-60'>
                            <span className='eleHeader'>Never</span>
                        </td>
                        <td className='w-80'>
                            <span className='eleHeader'>Once Or Twice</span>
                        </td>
                        <td className='w-60'>
                            <span className='eleHeader'>Monthly</span>
                        </td>
                        <td className='w-60'>
                            <span className='eleHeader'>Weekly</span>
                        </td>
                        <td className='w-100'>
                            <span className='eleHeader'>Daily or almost daily</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>1. Tobacco products (cigarettes, chewing tobacco, cigars, etc.)</td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbTabacco_E_1' name='rbTabacco_E' className='add-only' value='Never' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbTabacco_E_2' name='rbTabacco_E' className='add-only' value='OnceOrTwice' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbTabacco_E_3' name='rbTabacco_E' className='add-only' value='Monthly' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbTabacco_E_4' name='rbTabacco_E' className='add-only' value='Weekly' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbTabacco_E_5' name='rbTabacco_E' className='add-only' value='DaliyOrAlmostDaily' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>2. Alcoholic beverages (beer, wine, spirits, etc.)</td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbAlcoholic_E_1' name='rbAlcoholic_E' className='add-only' value='Never' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbAlcoholic_E_2' name='rbAlcoholic_E' className='add-only' value='OnceOrTwice' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbAlcoholic_E_3' name='rbAlcoholic_E' className='add-only' value='Monthly' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbAlcoholic_E_4' name='rbAlcoholic_E' className='add-only' value='Weekly' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbAlcoholic_E_5' name='rbAlcoholic_E' className='add-only' value='DaliyOrAlmostDaily' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>3. Cannabis (marijuana , pot, grass, hash, etc.)</td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbCannabis_E_1' name='rbCannabis_E' className='add-only' value='Never' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbCannabis_E_2' name='rbCannabis_E' className='add-only' value='OnceOrTwice' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbCannabis_E_3' name='rbCannabis_E' className='add-only' value='Monthly' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbCannabis_E_4' name='rbCannabis_E' className='add-only' value='Weekly' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbCannabis_E_5' name='rbCannabis_E' className='add-only' value='DaliyOrAlmostDaily' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>4. Cocaine  (coke, crack, etc.)</td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbCocaine_E_1' name='rbCocaine_E' className='add-only' value='Never' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbCocaine_E_2' name='rbCocaine_E' className='add-only' value='OnceOrTwice' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbCocaine_E_3' name='rbCocaine_E' className='add-only' value='Monthly' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbCocaine_E_4' name='rbCocaine_E' className='add-only' value='Weekly' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbCocaine_E_5' name='rbCocaine_E' className='add-only' value='DaliyOrAlmostDaily' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>5. Amphetamine type stimulants (speed, diet pills, ecstasy, etc.)</td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbAmphetamine_E_1' name='rbAmphetamine_E' className='add-only' value='Never' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbAmphetamine_E_2' name='rbAmphetamine_E' className='add-only' value='OnceOrTwice' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbAmphetamine_E_3' name='rbAmphetamine_E' className='add-only' value='Monthly' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbAmphetamine_E_4' name='rbAmphetamine_E' className='add-only' value='Weekly' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbAmphetamine_E_5' name='rbAmphetamine_E' className='add-only' value='DaliyOrAlmostDaily' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>6. Inhalants (nitrous, glue, petrol, paint thinner, etc.)
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbInhalants_E_1' name='rbInhalants_E' className='add-only' value='Never' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbInhalants_E_2' name='rbInhalants_E' className='add-only' value='OnceOrTwice' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbInhalants_E_3' name='rbInhalants_E' className='add-only' value='Monthly' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbInhalants_E_4' name='rbInhalants_E' className='add-only' value='Weekly' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbInhalants_E_5' name='rbInhalants_E' className='add-only' value='DaliyOrAlmostDaily' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>7. Sedatives or sleeping pills (Valium, Serepax, Rohypnol, etc.)
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbSedatives_E_1' name='rbSedatives_E' className='add-only' value='Never' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbSedatives_E_2' name='rbSedatives_E' className='add-only' value='OnceOrTwice' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbSedatives_E_3' name='rbSedatives_E' className='add-only' value='Monthly' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbSedatives_E_4' name='rbSedatives_E' className='add-only' value='Weekly' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbSedatives_E_5' name='rbSedatives_E' className='add-only' value='DaliyOrAlmostDaily' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>8. Hallucinogens (LSD, acid, mushrooms, PCP, Special K, etc.)</td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbHallucinogens_E_1' name='rbHallucinogens_E' className='add-only' value='Never' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbHallucinogens_E_2' name='rbHallucinogens_E' className='add-only' value='OnceOrTwice' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbHallucinogens_E_3' name='rbHallucinogens_E' className='add-only' value='Monthly' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbHallucinogens_E_4' name='rbHallucinogens_E' className='add-only' value='Weekly' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHallucinogens_E_5' name='rbHallucinogens_E' className='add-only' value='DaliyOrAlmostDaily' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>9.	Opioids (heroin, morphine, methadone, codeine, etc.)</td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbOpioids_E_1' name='rbOpioids_E' className='add-only' value='Never' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbOpioids_E_2' name='rbOpioids_E' className='add-only' value='OnceOrTwice' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbOpioids_E_3' name='rbOpioids_E' className='add-only' value='Monthly' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbOpioids_E_4' name='rbOpioids_E' className='add-only' value='Weekly' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbOpioids_E_5' name='rbOpioids_E' className='add-only' value='DaliyOrAlmostDaily' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>10.	Other - Specify:
                            <input type='text' id='txtOtherSpecify_E' name='txtOtherSpecify_E' className='add-only' />
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbOtherSpecify_E_1' name='rbOtherSpecify_E' className='add-only' value='Never' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbOtherSpecify_E_2' name='rbOtherSpecify_E' className='add-only' value='OnceOrTwice' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbOtherSpecify_E_3' name='rbOtherSpecify_E' className='add-only' value='Monthly' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbOtherSpecify_E_4' name='rbOtherSpecify_E' className='add-only' value='Weekly' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbOtherSpecify_E_5' name='rbOtherSpecify_E' className='add-only' value='DaliyOrAlmostDaily' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>
                            <span className='eleHeader'>F. Have you ever tried and failed to control, cut down, or stop using the following:</span>
                        </td>
                        <td className='w-60'>
                            <span className='eleHeader'>Never</span>
                        </td>
                        <td className='w-80'>
                            <span className='eleHeader'>Once Or Twice</span>
                        </td>
                        <td className='w-60'>
                            <span className='eleHeader'>Monthly</span>
                        </td>
                        <td className='w-60'>
                            <span className='eleHeader'>Weekly</span>
                        </td>
                        <td className='w-100'>
                            <span className='eleHeader'>Daily or almost daily</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>1. Tobacco products (cigarettes, chewing tobacco, cigars, etc.)</td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbTabacco_F_1' name='rbTabacco_F' className='add-only' value='Never' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbTabacco_F_2' name='rbTabacco_F' className='add-only' value='OnceOrTwice' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbTabacco_F_3' name='rbTabacco_F' className='add-only' value='Monthly' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbTabacco_F_4' name='rbTabacco_F' className='add-only' value='Weekly' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbTabacco_F_5' name='rbTabacco_F' className='add-only' value='DaliyOrAlmostDaily' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>2. Alcoholic beverages (beer, wine, spirits, etc.)</td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbAlcoholic_F_1' name='rbAlcoholic_F' className='add-only' value='Never' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbAlcoholic_F_2' name='rbAlcoholic_F' className='add-only' value='OnceOrTwice' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbAlcoholic_F_3' name='rbAlcoholic_F' className='add-only' value='Monthly' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbAlcoholic_F_4' name='rbAlcoholic_F' className='add-only' value='Weekly' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbAlcoholic_F_5' name='rbAlcoholic_F' className='add-only' value='DaliyOrAlmostDaily' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>3. Cannabis (marijuana , pot, grass, hash, etc.)</td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbCannabis_F_1' name='rbCannabis_F' className='add-only' value='Never' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbCannabis_F_2' name='rbCannabis_F' className='add-only' value='OnceOrTwice' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbCannabis_F_3' name='rbCannabis_F' className='add-only' value='Monthly' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbCannabis_F_4' name='rbCannabis_F' className='add-only' value='Weekly' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbCannabis_F_5' name='rbCannabis_F' className='add-only' value='DaliyOrAlmostDaily' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>4. Cocaine  (coke, crack, etc.)</td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbCocaine_F_1' name='rbCocaine_F' className='add-only' value='Never' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbCocaine_F_2' name='rbCocaine_F' className='add-only' value='OnceOrTwice' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbCocaine_F_3' name='rbCocaine_F' className='add-only' value='Monthly' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbCocaine_F_4' name='rbCocaine_F' className='add-only' value='Weekly' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbCocaine_F_5' name='rbCocaine_F' className='add-only' value='DaliyOrAlmostDaily' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>5. Amphetamine type stimulants (speed, diet pills, ecstasy, etc.)</td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbAmphetamine_F_1' name='rbAmphetamine_F' className='add-only' value='Never' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbAmphetamine_F_2' name='rbAmphetamine_F' className='add-only' value='OnceOrTwice' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbAmphetamine_F_3' name='rbAmphetamine_F' className='add-only' value='Monthly' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbAmphetamine_F_4' name='rbAmphetamine_F' className='add-only' value='Weekly' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbAmphetamine_F_5' name='rbAmphetamine_F' className='add-only' value='DaliyOrAlmostDaily' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>6. Inhalants (nitrous, glue, petrol, paint thinner, etc.)
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbInhalants_F_1' name='rbInhalants_F' className='add-only' value='Never' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbInhalants_F_2' name='rbInhalants_F' className='add-only' value='OnceOrTwice' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbInhalants_F_3' name='rbInhalants_F' className='add-only' value='Monthly' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbInhalants_F_4' name='rbInhalants_F' className='add-only' value='Weekly' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbInhalants_F_5' name='rbInhalants_F' className='add-only' value='DaliyOrAlmostDaily' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>7. Sedatives or sleeping pills (Valium, Serepax, Rohypnol, etc.)
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbSedatives_F_1' name='rbSedatives_F' className='add-only' value='Never' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbSedatives_F_2' name='rbSedatives_F' className='add-only' value='OnceOrTwice' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbSedatives_F_3' name='rbSedatives_F' className='add-only' value='Monthly' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbSedatives_F_4' name='rbSedatives_F' className='add-only' value='Weekly' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbSedatives_F_5' name='rbSedatives_F' className='add-only' value='DaliyOrAlmostDaily' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>8. Hallucinogens (LSD, acid, mushrooms, PCP, Special K, etc.)</td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbHallucinogens_F_1' name='rbHallucinogens_F' className='add-only' value='Never' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbHallucinogens_F_2' name='rbHallucinogens_F' className='add-only' value='OnceOrTwice' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbHallucinogens_F_3' name='rbHallucinogens_F' className='add-only' value='Monthly' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbHallucinogens_F_4' name='rbHallucinogens_F' className='add-only' value='Weekly' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbHallucinogens_F_5' name='rbHallucinogens_F' className='add-only' value='DaliyOrAlmostDaily' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>9.	Opioids (heroin, morphine, methadone, codeine, etc.)</td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbOpioids_F_1' name='rbOpioids_F' className='add-only' value='Never' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbOpioids_F_2' name='rbOpioids_F' className='add-only' value='OnceOrTwice' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbOpioids_F_3' name='rbOpioids_F' className='add-only' value='Monthly' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbOpioids_F_4' name='rbOpioids_F' className='add-only' value='Weekly' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbOpioids_F_5' name='rbOpioids_F' className='add-only' value='DaliyOrAlmostDaily' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>10.	Other - Specify:
                            <input type='text' id='txtOtherSpecify_F' name='txtOtherSpecify_F' className='add-only' />
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbOtherSpecify_F_1' name='rbOtherSpecify_F' className='add-only' value='Never' /></center>
                        </td>
                        <td className='w-80'>
                            <center><input type='radio' id='rbOtherSpecify_F_2' name='rbOtherSpecify_F' className='add-only' value='OnceOrTwice' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbOtherSpecify_F_3' name='rbOtherSpecify_F' className='add-only' value='Monthly' /></center>
                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbOtherSpecify_F_4' name='rbOtherSpecify_F' className='add-only' value='Weekly' /></center>
                        </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbOtherSpecify_F_5' name='rbOtherSpecify_F' className='add-only' value='DaliyOrAlmostDaily' /></center>
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-390'>
                            <span className='eleHeader'>G. Have you ever used any drug by injection (non-medical injection)?</span>
                        </td>
                        <td className='w-60'><span className='eleHeader'>Never</span></td>
                        <td className='w-150'><span className='eleHeader'>Yes, in the past 3 months</span></td>
                        <td className='w-150'><span className='eleHeader'>Yes, but not in the past 3 months</span></td>
                    </tr>
                    <tr>
                        <td className='w-390'>1. Tobacco products (cigarettes, chewing tobacco, cigars, etc.)</td>

                        <td className='w-60'>
                            <center><input type='radio' id='rbTabacco_G_1' name='rbTabacco_G' className='add-only' value='Never' /></center>
                        </td>
                        <td className='w-150'>
                            <center><input type='radio' id='rbTabacco_G_2' name='rbTabacco_G' className='add-only' value='YesThePast3Months' /></center>
                        </td>
                        <td className='w-150'>
                            <center><input type='radio' id='rbTabacco_G_3' name='rbTabacco_G' className='add-only' value='YesButNotThePast3Months' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>2. Alcoholic beverages (beer, wine, spirits, etc.)</td>

                        <td className='w-60'>
                            <center><input type='radio' id='rbAlcoholic_G_1' name='rbAlcoholic_G' className='add-only' value='Never' /></center>
                        </td>
                        <td className='w-150'>
                            <center><input type='radio' id='rbAlcoholic_G_2' name='rbAlcoholic_G' className='add-only' value='YesThePast3Months' /></center>
                        </td>
                        <td className='w-150'>
                            <center><input type='radio' id='rbAlcoholic_G_3' name='rbAlcoholic_G' className='add-only' value='YesButNotThePast3Months' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>3. Cannabis (marijuana , pot, grass, hash, etc.)</td>

                        <td className='w-60'>
                            <center><input type='radio' id='rbCannabis_G_1' name='rbCannabis_G' className='add-only' value='Never' /></center>
                        </td>
                        <td className='w-150'>
                            <center><input type='radio' id='rbCannabis_G_2' name='rbCannabis_G' className='add-only' value='YesThePast3Months' /></center>
                        </td>
                        <td className='w-150'>
                            <center><input type='radio' id='rbCannabis_G_3' name='rbCannabis_G' className='add-only' value='YesButNotThePast3Months' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>4. Cocaine  (coke, crack, etc.)</td>

                        <td className='w-60'>
                            <center><input type='radio' id='rbCocaine_G_1' name='rbCocaine_G' className='add-only' value='Never' /></center>
                        </td>
                        <td className='w-150'>
                            <center><input type='radio' id='rbCocaine_G_2' name='rbCocaine_G' className='add-only' value='YesThePast3Months' /></center>
                        </td>
                        <td className='w-150'>
                            <center><input type='radio' id='rbCocaine_G_3' name='rbCocaine_G' className='add-only' value='YesButNotThePast3Months' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>5. Amphetamine type stimulants (speed, diet pills, ecstasy, etc.)</td>

                        <td className='w-60'>
                            <center><input type='radio' id='rbAmphetamine_G_1' name='rbAmphetamine_G' className='add-only' value='Never' /></center>
                        </td>
                        <td className='w-150'>
                            <center><input type='radio' id='rbAmphetamine_G_2' name='rbAmphetamine_G' className='add-only' value='YesThePast3Months' /></center>
                        </td>
                        <td className='w-150'>
                            <center><input type='radio' id='rbAmphetamine_G_3' name='rbAmphetamine_G' className='add-only' value='YesButNotThePast3Months' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>6. Inhalants (nitrous, glue, petrol, paint thinner, etc.)</td>

                        <td className='w-60'>
                            <center><input type='radio' id='rbInhalants_G_1' name='rbInhalants_G' className='add-only' value='Never' /></center>
                        </td>
                        <td className='w-150'>
                            <center><input type='radio' id='rbInhalants_G_2' name='rbInhalants_G' className='add-only' value='YesThePast3Months' /></center>
                        </td>
                        <td className='w-150'>
                            <center><input type='radio' id='rbInhalants_G_3' name='rbInhalants_G' className='add-only' value='YesButNotThePast3Months' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>7. Sedatives or sleeping pills (Valium, Serepax, Rohypnol, etc.)</td>

                        <td className='w-60'>
                            <center><input type='radio' id='rbSedatives_G_1' name='rbSedatives_G' className='add-only' value='Never' /></center>
                        </td>
                        <td className='w-150'>
                            <center><input type='radio' id='rbSedatives_G_2' name='rbSedatives_G' className='add-only' value='YesThePast3Months' /></center>
                        </td>
                        <td className='w-150'>
                            <center><input type='radio' id='rbSedatives_G_3' name='rbSedatives_G' className='add-only' value='YesButNotThePast3Months' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>8. Hallucinogens (LSD, acid, mushrooms, PCP, Special K, etc.)</td>

                        <td className='w-60'>
                            <center><input type='radio' id='rbHallucinogens_G_1' name='rbHallucinogens_G' className='add-only' value='Never' /></center>
                        </td>
                        <td className='w-150'>
                            <center><input type='radio' id='rbHallucinogens_G_2' name='rbHallucinogens_G' className='add-only' value='YesThePast3Months' /></center>
                        </td>
                        <td className='w-150'>
                            <center><input type='radio' id='rbHallucinogens_G_3' name='rbHallucinogens_G' className='add-only' value='YesThePast3Months' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>9. Opioids (heroin, morphine, methadone, codeine, etc.)</td>

                        <td className='w-60'>
                            <center><input type='radio' id='rbOpioids_G_1' name='rbOpioids_G' className='add-only' value='Never' /></center>
                        </td>
                        <td className='w-150'>
                            <center><input type='radio' id='rbOpioids_G_2' name='rbOpioids_G' className='add-only' value='YesThePast3Months' /></center>
                        </td>
                        <td className='w-150'>
                            <center><input type='radio' id='rbOpioids_G_3' name='rbOpioids_G' className='add-only' value='YesThePast3Months' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-390'>10.	Other - Specify:<input type='text' id='txtOtherSpecify_G' name='txtOtherSpecify_G' className='add-only' />

                        </td>
                        <td className='w-60'>
                            <center><input type='radio' id='rbOtherSpecify_G_1' name='rbOtherSpecify_G' className='add-only' value='Never' /></center>
                        </td>
                        <td className='w-150'>
                            <center><input type='radio' id='rbOtherSpecify_G_2' name='rbOtherSpecify_G' className='add-only' value='YesThePast3Months' /></center>
                        </td>
                        <td className='w-150'>
                            <center><input type='radio' id='rbOtherSpecify_G_3' name='rbOtherSpecify_G' className='add-only' value='YesThePast3Months' /></center>
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Does client report being exposed to drugs in his/her family of origin?</span>
                    <input type='radio' id='rbFamilyofRegion_Yes' name='rbFamilyofRegion' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbFamilyofRegion_No' name='rbFamilyofRegion' className='add-only' value='No' /> No
                    <span className='small'>Please explain:</span>
                    <textarea id='txtFamilyofRegion' name='txtFamilyofRegion' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Does client report being exposed to alcohol in his/her family of origin?</span>
                    <input type='radio' id='rbBeingAlcohal_Yes' name='rbBeingAlcohal' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbBeingAlcohal_No' name='rbBeingAlcohal' className='add-only' value='No' /> No
                    <span className='small'>Please explain:</span>
                    <textarea id='txtBeingAlcohal' name='txtBeingAlcohal' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Does client report exhibiting any addictive behaviors beyond drugs or alcohol?</span>
                    <span className='small'>(e.g., binge eating, excessive shopping)</span>
                    <input type='radio' id='rbDrugOrAlcohal_Yes' name='rbDrugOrAlcohal' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbDrugOrAlcohal_No' name='rbDrugOrAlcohal' className='add-only' value='No' /> No
                    <span className='small'>Please explain:</span>
                    <textarea id='txtDrugOrAlcohal' name='txtDrugOrAlcohal' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Does client report any addictive behaviors beyond drugs or alcohol in his/her family of origin?</span>
                    <span className='small'>(e.g., binge eating, excessive shopping)</span>
                    <input type='radio' id='rbAddictiveBehavior_Yes' name='rbAddictiveBehavior' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbAddictiveBehavior_No' name='rbAddictiveBehavior' className='add-only' value='No' /> No
                    <span className='small'>Please explain:</span>
                    <textarea id='txtAddictiveBehavior' name='txtAddictiveBehavior' className='add-only'></textarea>
                </p>
                <p className='w-750'><h2>Clients Strengths, Needs, Abilities, And Preferences (SNAP)</h2></p>
                <p className='w-750'>
                    <span className='eleHeader'>Client Strengths</span>
                    <textarea id='txtClientStrengths' name='txtClientStrengths' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Client Needs</span>
                    <textarea id='txtClientNeeds' name='txtClientNeeds' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Client Abilities</span>
                    <textarea id='txtClientAbilities' name='txtClientAbilities' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Client Preferences</span>
                    <textarea id='txtClientPreferences' name='txtClientPreferences' className='add-only'></textarea>
                </p>
                <p className='w-750'><h2>Client Preferences Related To Culture, Spiritual Beliefs, Religion, Diet Or Appearance</h2></p>
                <p className='w-750'>
                    <span className='eleHeader'>Preferences related to culture</span>
                    <textarea id='txtRelatedCulture' name='txtRelatedCulture' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Preferences related to spiritual beliefs</span>
                    <textarea id='txtSpiritualBeliefs' name='txtSpiritualBeliefs' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Preferences related to religion</span>
                    <textarea id='txtRelatedReligion' name='txtRelatedReligion' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Preferences related to diet</span>
                    <textarea id='txtRelatedDiet' name='txtRelatedDiet' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Preferences related to appearance</span>
                    <textarea id='txtRelatedAppearance' name='txtRelatedAppearance' className='add-only'></textarea>
                </p>
                <p className='w-750'><h2>Client Hobbies And Goals</h2></p>
                <p className='w-750'>
                    <span className='eleHeader'>Does the client have any hobbies</span>
                    <input type='radio' id='rbClientHobbies_Yes' name='rbClientHobbies' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbClientHobbies_No' name='rbClientHobbies' className='add-only' value='No' /> No
                    <span className='small'>Please explain:</span>
                    <textarea id='txtClientHobbies' name='txtClientHobbies' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Does the client have long-term goals</span>
                    <input type='radio' id='rbLongTermGoals_Yes' name='rbLongTermGoals' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbLongTermGoals_No' name='rbLongTermGoals' className='add-only' value='No' /> No
                    <span className='small'>Please explain:</span>
                    <textarea id='txtLongTermGoals' name='txtLongTermGoals' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Does the client have short-term goals</span>
                    <input type='radio' id='rbShortTermGoals_Yes' name='rbShortTermGoals' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbShortTermGoals_No' name='rbShortTermGoals' className='add-only' value='No' /> No
                    <span className='small'>Please explain:</span>
                    <textarea id='txtShortTermGoals' name='txtShortTermGoals' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Summary of Identified Mental Health, Behavioral, And/Or Substance Abuse Needs/Concerns</span>
                    <span className='small'>(Include an evaluation of past interventions and a summary of the support for therapy, psychosocial rehabilitation, and psychiatric/medication services needed.  Summarize assessment information including history and testing, discuss central themes, and detail outcomes and recommendations)</span>
                    <textarea id='txtMentalHealthBehavioral' name='txtMentalHealthBehavioral' className='add-only'></textarea>
                </p>

                <p className='w-750'><h2>Diagnostic Impressions</h2></p>

                <p className='w-750'>
                    <span className='eleHeader'>(DSM-5)</span>
                    <textarea id='txtDSM_5' name='txtDSM_5' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>(ICD-10)</span>
                    <textarea id='txtICD_10' name='txtICD_10' className='add-only'></textarea>
                </p>

                <p className='w-750'><h2>Treatment Recommendations</h2></p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Based on this Assessment, the client</span>
                            <input type='text' id='txtBasedOnAssessment' name='txtBasedOnAssessment' className='add-only' />
                        </td>
                    </tr>
                </table>


                <p className='w-750'>
                    <input type='text' id='txtDiagnosticCriteria' name='txtDiagnosticCriteria' className='add-only w-350 custom-add-only' /> &nbsp;
                    <b>Does not meet diagnostic criteria</b> is not eligible for Community Mental Health Services. Therefore, the client will be:
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbPathBehavioralHealth' name='cbPathBehavioralHealth' className='add-only' value='1' />
                            Discharged from Northwest Behavioral Health Services
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbExternalProvider' name='cbExternalProvider' className='add-only' value='1' />
                            Referred to an external provider or agency: &nbsp;
                            <input type='text' id='txtExternalProvider' name='txtExternalProvider' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                </table>


                <p className='w-750'>
                    <input type='text' id='txtDiagnosticCriteriaICD_10' name='txtDiagnosticCriteriaICD_10' className='add-only w-250 custom-add-only' /> &nbsp;
                    <b>Meets diagnostic criteria for</b> an ICD-10 diagnosis(es) of F01 through F99
                    290 through 298.9,300 through 301.9, 302.7, 303 through 312.4 and 312.81 through 314.9, 315.3, 315.31, 315.5, 315.8 and 315.9
                    and is recommended for the following services:
                </p>


                <table>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbBriefBehavior' name='cbBriefBehavior' className='add-only' value='1' />
                            Brief Behavior Health Exam
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbFamilyTherapy' name='cbFamilyTherapy' className='add-only' value='1' />
                            Individual/Family Therapy
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbPsychiatricEvaluation' name='cbPsychiatricEvaluation' className='add-only' value='1' />
                            Psychiatric Evaluation
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbGroupTherapy' name='cbGroupTherapy' className='add-only' value='1' />
                            Group Therapy
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbMedicationManagement' name='cbMedicationManagement' className='add-only' value='1' />
                            Medication Management
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbTargetCaseManagement' name='cbTargetCaseManagement' className='add-only' value='1' />
                            Target Case Management
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAnInDepthAssessment' name='cbAnInDepthAssessment' className='add-only' value='1' />
                            An In-Depth Assessment
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbTBOSTherapy' name='cbTBOSTherapy' className='add-only' value='1' />
                            TBOS-Therapy
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbTBOSSupportServices' name='cbTBOSSupportServices' className='add-only' value='1' />
                            TBOS- Support Services
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbTBOSBehaviorManagement' name='cbTBOSBehaviorManagement' className='add-only' value='1' />
                            TBOS- Behavior Management
                        </td>
                        <td className='w-500'>
                            <input type='checkbox' id='cbCommunitySupportServices' name='cbCommunitySupportServices' className='add-only' value='1' />
                            Community Support Services (PSR)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbTR_Other' name='cbTR_Other' className='add-only' value='1' />
                            Other: &nbsp;
                            <input type='text' id='txtTR_Other' name='txtTR_Other' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                </table>


                <p className='w-750'><h2> Therapeutic Behavioral Onsite Services - Eligibility Checklist and Certification / Recertification</h2></p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Client's Name</span>
                            <input type='text' id='txtTherapeutic_ClientName' name='txtTherapeutic_ClientName' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Date</span>
                            <input type='text' id='txtTherapeutic_Clientdate' name='txtTherapeutic_Clientdate' className='add-only' />
                        </td>
                    </tr>
                </table>
                <span className='small'>Please answer the following questions to determine if the recipient is eligible for
                    TBOS Services. If the recipient is deemed eligible, ensure the services are prescribed in the Treatment Plan.
                    Continued eligibility must be reassessed at least once every six months.</span>
                <p className='w-750'>
                    <span className='eleHeader'>Is the client under 21 years of age?</span>
                    <input type='radio' id='rb21Years_Yes' name='rb21Years' className='add-only' value='Yes' /> Yes - 
                    If the client is under 21 years of age please move on to the next question.<br />
                    <input type='radio' id='rb21Years_No' name='rb21Years' className='add-only' value='No' /> No - 
                    The client is not eligible for TBOS Services.  There is no need to continue to the next question.
                    Please review eligibility criteria for Individual and Family Therapy to determine if client meets criteria.
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Is the recipient at risk of out of home placement?</span>
                    <span className='small'>(For example: incarceration, Baker Act, inpatient placement, therapeutic-foster home,
                        respite services, independent living facilities, or homelessness)</span>
                    <input type='radio' id='rbTBOSServices_Yes' name='rbTBOSServices' className='add-only' value='Yes' /> Yes - 
                    If the recipient is at risk of out of home placement, please move on to the next question.
                    <br />
                    <input type='radio' id='rbTBOSServices_No' name='rbTBOSServices' className='add-only' value='No' /> No - 
                    The recipient is not eligible for TBOS Services.  There is no need to continue to the next question.
                    Please review eligibility criteria for Individual and Family Therapy to determine if recipient meets criteria.
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Does the recipient have an ICD-10 diagnosis in the following range?</span>
                    <span className='small'>290-298.9, 300-301.9, 302.7, 303-312.4, 312.81-314.9, 315.3, 315.31, 315.5, 315.8-315.9</span>
                    <input type='radio' id='rbICDDiagnosis_Yes' name='rbICDDiagnosis' className='add-only' value='Yes' /> Yes - 
                    Provide recipient's diagnosis below, then move on to the next question.<br />
                </p>
                <table>
                    <tr>
                        <td className='w-750'>Recipient's Diagnosis: &nbsp;
                            <input type='text' id='txtRecepientDiagnosis' name='txtRecepientDiagnosis' className='add-only w-500 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <input type='radio' id='rbICDDiagnosis_No' name='rbICDDiagnosis' className='add-only' value='No' /> No - 
                    The recipient is not eligible for TBOS Services.  There is no need to continue to the next question.
                    Please review eligibility criteria for Individual and Family Therapy to determine if recipient meets criteria.
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Has the recipient scored a 60 or below on the CGAS within the last month; or has a diagnosis of 295-298.9?</span>
                    <input type='radio' id='rbCGAS_Yes' name='rbCGAS' className='add-only' value='Yes' /> Yes - 
                    Provide recipient's CGAS score below or indicate recipient meets diagnostic criteria, then move on to the next question
                </p>
                <table>
                    <tr>
                        <td className='w-400'>Recipient's CGAS Score: &nbsp;
                            <input type='text' id='txtCGAS' name='txtCGAS' className='add-only w-200 custom-add-only' />
                        </td>
                        <td className='w-30'>or</td>
                        <td className='w-320'>
                            <input type='checkbox' id='cbMeetDiagnostic' name='cbMeetDiagnostic' className='add-only' value='1' />
                            Meets diagnostic criteria
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <input type='radio' id='rbCGAS_No' name='rbCGAS' className='add-only' value='No' /> No - 
                    The recipient is not eligible for TBOS Services.  There is no need to continue to the next question.
                    Please review eligibility criteria for Individual and Family Therapy to determine if recipient meets criteria.
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Please answer the questions for the age grouping that appropriately matches the recipient.</span>
                            Recipient's Age: &nbsp;
                            <input type='text' id='txtRecepient' name='txtRecepient' className='add-only w-150 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Two Years and Under</span>
                    <span className='small'>Please indicate if the recipient meets any of the following criteria. The recipient must
                        meet at least one of the following criteria to be eligible for TBOS Services:</span>
                    <input type='checkbox' id='cbExhibitsSymptoms' name='cbExhibitsSymptoms' className='add-only' value='1' />
                    Exhibits symptoms of an emotional or behavioral nature that are atypical for the recipient's age and development
                    that interferes with social interaction and relationship development.<br />
                    <input type='checkbox' id='cbExhibitsFailure' name='cbExhibitsFailure' className='add-only' value='1' />
                    Exhibits failure to thrive (due to emotional or psychosocial causes, not solely medical issues).
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Ages Two to Five Years</span>
                    <span className='small'>Please indicate if the recipient meets any of the following criteria. The recipient must
                        meet at least both of the following criteria to be eligible for TBOS Services:</span>
                    <input type='checkbox' id='cbExhibits' name='cbExhibits' className='add-only' value='1' />
                    Exhibits symptoms of an emotional or behavioral nature that are atypical for the recipient's age and development.<br />
                    <input type='checkbox' id='cbScores' name='cbScores' className='add-only' value='1' />
                    Scores in at least the moderate impairment range on a behavior and functional rating scale developed for the specific age group (CFARS or FARS).
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Ages Six to Seventeen Years</span>
                    <span className='small'>Please indicate if the recipient meets any of the following criteria. The recipient must meet at
                        least one of the following criteria to be eligible for TBOS Services:</span>
                    <input type='radio' id='rbEmotionalDisturbance' name='rbEmotional' className='add-only' value='Has an emotional disturbance' />
                    Has an emotional disturbance
                    <input type='radio' id='rbSeriousEmotionalDisturbance' name='rbEmotional' className='add-only' value='Has a serious emotional disturbance' />
                    Has a serious emotional disturbance
                    <input type='radio' id='rbSubstanceDisorder' name='rbEmotional' className='add-only' value='Has a substance use disorder' />
                    Has a substance use disorder
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Ages Eighteen to Twenty Years</span>
                    <span className='small'>Please indicate if the recipient meets any of the following criteria. The recipient must meet at
                        least one of the following criteria to be eligible for TBOS Services:</span><br />
                    <input type='text' id='txtEmotionalDisturbance' name='txtEmotionalDisturbance' className='add-only w-150 custom-add-only' /> &nbsp;
                    Meets the criteria for an emotional disturbance or a serious emotional disturbance.
                </p>
                <p className='w-750'><b>This document serves as an eligibility checklist and certification that:</b></p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Client's Name</span>
                            <input type='text' id='txtDocument_ClientsName' name='txtDocument_ClientsName' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Medicaid #</span>
                            <input type='text' id='txtDocument_MedicaidNo' name='txtDocument_MedicaidNo' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>was screened and determined to meet the clinical eligibility criteria to receive </p>
                <p className='w-750'><h4>Therapeutic Behavioral Onsite Services</h4></p>

            </div >
        </form >

    )
}

